// Simple i18n dictionary for AR (default) and EN.
export const STRINGS = {
  ar: {
    kit_tab_phrases: "عبارات",
    kit_tab_packing: "الحقيبة",
    phrases_search: "ابحث عن عبارة…",
    phrases_play: "استمع إلى النطق",
    phrases_voice_hint: "للصوت دون اتصال ثبّت الصوت العربي من إعدادات الهاتف (تحويل النص إلى كلام).",
    pack_docs: "وثائق ونقود",
    pack_clothes: "ملابس",
    pack_health: "صحة",
    pack_tech: "تقنية",
    pack_extra: "إضافات مفيدة",
    packing_reset: "إعادة ضبط",
    diary_title: "يوميات الرحلة",
    diary_visited: "تمت زيارتها",
    diary_complete_title: "أكملت رحلة {country}!",
    diary_complete_desc: "حصلت على ختم اليوميات في جواز السفر و+5 نقاط",
    badge_diary: "يوميات الرحلة",
    diary_badge_req: "علّم كل محطات برنامج واحد لتحصل على الختم",
    diary_badge_done: "{n} رحلات مكتملة بكل محطاتها",
    diary_badge_done_one: "رحلة واحدة مكتملة بكل محطاتها",
    guess_by: "تحدّي {name}",
    guess_counter: "أنشئ تحدّيك",
    guess_board_title: "ترتيب التحدّيات",
    guess_board_sub: "3 نقاط من المحاولة الأولى، 2 من الثانية، 1 من الثالثة · {n} لاعبين",
    guess_name_placeholder: "اسمك في الترتيب",
    guess_name_saved: "تم حفظ الاسم",
    guess_you: "أنت",
    album_title: "ألبوم الرحلة",
    album_add: "أضف صورة لهذه المحطة",
    album_added: "أُضيفت الصورة إلى الألبوم",
    group_title: "أصدقاء في الرحلة",
    group_btn: "الأصدقاء",
    group_sub: "أنشئ رمزاً لـ{country} أو أدخل رمز صديق: ستتابعون البرنامج نفسه وترون من زار ماذا.",
    group_sub_active: "المجموعة تتابع برنامج {country}. تتحدث العلامات تلقائياً.",
    group_name_placeholder: "اسمك في المجموعة",
    group_create: "أنشئ رمز مجموعة",
    group_or: "أو",
    group_join: "انضم",
    group_hint: "بدون تسجيل: تبقى المجموعة 60 يوماً ثم تُحذف تلقائياً.",
    group_code_label: "رمز المجموعة",
    group_invite: "ادعُ",
    group_copy: "نسخ",
    group_share_text: "سافر معي! أدخل الرمز {code} في أطلس العالم العربي ولنتابع البرنامج نفسه ✈️",
    group_progress: "زارت المجموعة {n} من {total} محطات",
    group_members_hint: "{n} في المجموعة · تحديث كل 20 ثانية",
    group_you: "أنت",
    group_leave: "مغادرة المجموعة",
    group_left: "غادرت المجموعة",
    group_joined: "أنت في المجموعة {code}",
    group_not_found: "الرمز غير موجود أو منتهي",
    group_full: "المجموعة مكتملة (20 شخصاً)",
    group_other_country: "مجموعتك {code} تتابع برنامج {country}.",
    group_open_trip: "افتح برنامج المجموعة",
    group_seen_by: "زارها {names}",
    loc_btn: "استخدم موقعي",
    loc_hint: "فقط عند اللمس: يبقى موقعك على هاتفك",
    loc_found: "أنت في {country}: تم ضبط البلد وأرقام الطوارئ",
    loc_far: "أنت على بعد {km} كم من {country}: هل تستخدمه؟",
    loc_use: "استخدم",
    receipt_title: "هل تريد الإيصال عبر البريد؟",
    receipt_sub: "نرسل لك تأكيد الشراء مع رابط لفتح الكتاب على جهاز آخر أيضاً. اختياري.",
    receipt_send: "إرسال",
    receipt_skip: "لا، شكراً",
    receipt_sent: "أُرسل الإيصال إلى {email}",
    receipt_privacy: "يُستخدم البريد فقط للإيصال واستعادة الشراء؛ يمكنك حذفه من «احذف بياناتي».",
    status_play: "Play Store",
    report_resolved: "شكراً: أزال الفريق المحتوى الذي أبلغت عنه",
    report_btn: "إبلاغ",
    report_title: "الإبلاغ عن هذا المحتوى",
    report_sub: "أخبرنا بالسبب: يراجعه الفريق في أقرب وقت. بعد 3 بلاغات يُعلَّق المحتوى فوراً.",
    report_spam: "رسائل مزعجة أو إعلان",
    report_offensive: "كراهية أو إهانة أو تحرش",
    report_inappropriate: "محتوى صريح أو عنيف",
    report_copyright: "انتهاك حقوق النشر",
    report_privacy: "بيانات شخصية أو صورة دون موافقة",
    report_other: "أخرى",
    report_note: "تفاصيل (اختياري)",
    report_send: "إرسال البلاغ",
    report_sent: "شكراً، وصل البلاغ إلى الفريق",
    report_error: "تعذر الإرسال، حاول مجدداً",
    report_hint: "البلاغ مجهول: نحتفظ فقط بمعرّف الجهاز لتجنب التكرار.",
    hide_author: "إخفاء محتوى {name}",
    hide_done: "لن ترى محتوى {name} على هذا الجهاز بعد الآن",
    rules_title: "قواعد المجتمع",
    rules_accept: "بالنشر أوافق على {rules} وأؤكد أن عمري 13 عاماً على الأقل.",
    rules_required: "يجب قبول قواعد المجتمع للنشر",
    status_reported: "المبلَّغ عنها",
    admin_reports_clear: "تجاهل البلاغات",
    admin_suspended: "معلَّق",
    reward_btn: "شاهد فيديو → +{n} نقاط",
    reward_title: "فيديو المكافأة",
    reward_sub: "شاهد إعلاناً قصيراً حتى النهاية واحصل على +{n} نقاط لشاراتك (3 مرات يومياً كحد أقصى).",
    reward_disclosure: "اختياري. النقاط تفتح الشارات في جواز السفر فقط، ولا قيمة نقدية لها ولا يمكن تحويلها. يمنح الأطلس المكافأة وليس Google.",
    reward_yes: "شاهد الإعلان",
    reward_no: "لا، شكراً",
    reward_none: "لا يوجد إعلان متاح الآن، حاول لاحقاً",
    arrival_title: "هل وصلت إلى {country}؟",
    arrival_desc: "أرقام الطوارئ والعملة والعبارات المفيدة جاهزة في عدة السفر.",
    arrival_cta: "افتح عدة الطوارئ",
    loc_found_dest: "تم ضبط الوجهة: {country}",
    loc_denied: "رُفض إذن الموقع: اختر البلد من الأعلام",
    loc_unavailable: "الموقع غير متاح: اختر البلد من الأعلام",
    album_card: "بطاقة ذكرى",
    album_card_sub: "رحلة {name} · {n} أيام",
    album_share_text: "ألبوم رحلتي إلى {country} 📸 من أطلس العالم العربي",
    album_saved: "حُفظت البطاقة في هاتفك",
    album_private: "تبقى الصور على هاتفك فقط ولا تُرفع أبداً.",
    delete: "حذف",
    story_ambience: "أصوات محيطة (سوق، صحراء، بحر)",
    save: "حفظ",
    guess_board_empty: "لا لاعبين بعد: كن الأول!",
    kit_title: "عدة السفر",
    kit_sub: "طوارئ وعملة ومترجم — حتى دون إنترنت",
    kit_offline_mode: "أنت دون اتصال: البيانات محفوظة على هاتفك",
    kit_offline_empty: "افتح هذه الصفحة مرة واحدة مع الاتصال لحفظ البيانات دون إنترنت.",
    kit_tab_sos: "طوارئ",
    kit_tab_currency: "العملة",
    kit_tab_camera: "المترجم",
    kit_embassy: "ابحث عن سفارتك في خرائط Google",
    kit_embassy_query: "سفارة",
    kit_fx_flip: "اعكس",
    kit_fx_live: "سعر محدّث اليوم",
    kit_fx_cached: "آخر سعر محفوظ (دون اتصال)",
    kit_cam_cta: "صوّر قائمة طعام أو لافتة",
    kit_cam_hint: "يقرأ النص مباشرة على الهاتف؛ الترجمة تصل عند توفر الاتصال",
    kit_cam_reading: "جارٍ قراءة النص…",
    kit_cam_translating: "جارٍ الترجمة…",
    kit_cam_original: "النص المقروء",
    kit_cam_translation: "الترجمة",
    kit_cam_nothing: "لم أجد نصاً مقروءاً: اقترب وحاول مع إضاءة أفضل.",
    kit_cam_offline: "تمت قراءة النص، لكن الترجمة تحتاج إلى اتصال.",
    kit_cam_error: "فشلت القراءة، حاول مجدداً.",
    postcard_trip: "بطاقة بريدية",
    guess_challenge: "تحدَّ أصدقاءك",
    guess_share_text: "هل تخمّن وجهتي القادمة؟ 🧭 3 محاولات و23 علماً:",
    guess_title: "خمّن الوجهة",
    guess_sub: "اقرأ المحطات واختر البلد الصحيح. المحاولات المتبقية: {n}",
    guess_more_hints: "كل محاولة خاطئة تكشف يوماً إضافياً.",
    guess_won: "أصبت في المحاولة {n}! +2 نقطة إضافية و{p} في الترتيب",
    guess_lost: "ليس هذه المرة! الوجهة كانت…",
    guess_wrong: "لا… حاول مجدداً",
    guess_open_trip: "افتح البرنامج",
    guess_missing: "رابط غير صالح: اطلب من صديقك مشاركة التحدي مجدداً.",
    ob_intro: "خمس خطوات سريعة وسنبني لك برنامج رحلة ملوّناً يوماً بيوم.",
    ob_step: "الخطوة {n} من {total}",
    ob_name_title: "ما اسمك؟",
    ob_name_placeholder: "اسمك…",
    ob_origin_title: "من أين تسافر يا {name}؟",
    ob_origin_hint: "نستخدمه لضبط لغة الخريطة وعملة أسعار الفنادق والرحلات.",
    ob_dest_title: "إلى أين تريد الذهاب؟",
    ob_days_title: "كم يوماً ستبقى؟",
    ob_days_short: "رحلة قصيرة: مدينة واحدة وما حولها",
    ob_days_medium: "رحلة متوسطة: مدينتان أو منطقتان",
    ob_interests_title: "ما الذي يجذبك أكثر؟",
    ob_next: "التالي",
    ob_create: "أنشئ برنامجي",
    ob_skip: "تخطَّ",
    interest_culture: "ثقافة وتاريخ",
    interest_adventure: "مغامرة وصحراء",
    interest_shopping: "تسوّق وحداثة",
    style_culture: "حارس المدن العتيقة",
    style_adventure: "رحّالة الصحراء",
    style_shopping: "صيّاد الأسواق",
    style_culture_adventure: "مستكشف قديم",
    style_culture_shopping: "ذوّاق المدن",
    style_adventure_shopping: "مغامر عصري",
    style_culture_adventure_shopping: "المسافر الكامل",
    trip_style_hint: "هذا أسلوبك في السفر! شاركه مع أصدقائك.",
    trip_hello: "مرحباً {name} 👋",
    trip_sub: "برنامجك في {country} لمدة {n} أيام",
    trip_edit: "عدّل",
    trip_share: "شارك رحلتي",
    trip_share_text: "رحلتي إلى {country} في {n} أيام ✈️ — برنامج مجاني مع خريطة وأرقام الطوارئ:",
    trip_for_you: "مناسب لاهتماماتك",
    days_short: "أيام",
    tab_map: "الخريطة",
    tab_warnings: "تنبيهات ولباس",
    tab_food: "الطعام",
    tab_book: "احجز",
    trip_open_maps: "افتح المسار في خرائط Google",
    trip_map_unavailable: "الخريطة غير متاحة هنا، افتح المسار في خرائط Google.",
    dress_relaxed: "لباس مريح",
    dress_moderate: "لباس محتشم",
    dress_strict: "لباس محافظ",
    sos_title: "أرقام الطوارئ (تعمل دون إنترنت)",
    sos_unified: "الرقم الموحد",
    sos_police: "الشرطة",
    sos_ambulance: "الإسعاف",
    sos_fire: "الإطفاء",
    sos_tourist_police: "شرطة السياحة",
    trip_upsell: "هل تريد طهي هذه الأطباق في البيت؟ افتح كتاب الوصفات الكامل بـ 0,99 € فقط",
    trip_upsell_neutral: "هل تريد طهي هذه الأطباق في البيت؟ اكتشف كتاب الوصفات",
    book_hotels: "فنادق في {city}",
    book_compare: "قارن أسعار الفنادق",
    book_flights: "رحلات الطيران",
    book_tours: "جولات وتجارب في {city}",
    book_tickets: "تذاكر المتاحف والمعالم",
    book_partner: "رابط شريك",
    book_disclosure: "روابط شركاء: إذا حجزت عبرها يحصل الأطلس على عمولة صغيرة دون أي تكلفة إضافية عليك. تُفتح في المتصفح.",
    app_title: "أطلس العالم العربي",
    app_tagline: "خريطة تفاعلية لدول جامعة الدول العربية",
    search_placeholder: "ابحث عن دولة…",
    alphabet_menu: "الفهرس الأبجدي",
    all_countries: "كل الدول",
    map: "الخريطة",
    quiz: "اختبار",
    compare: "قارن",
    radio: "راديو",
    radio_title: "راديو الأطلس",
    radio_tagline: "{n} أغنية من العالم العربي، كلاسيكية وحديثة — استمع بالتتابع أو بشكل عشوائي.",
    radio_all: "الكل",
    overview_kicker: "الخلاصة",
    overview_cta: "العالم العربي كدولة واحدة",
    overview_sub: "التاريخ والسكان والاقتصاد معاً، ومقارنة مع الاتحاد الأوروبي والولايات المتحدة",
    radio_share: "شارك الأغنية",
    radio_share_text: "استمع إلى «{title}» لـ {artist} ({country}) على راديو الأطلس 🎵",
    radio_open: "افتح راديو الأطلس",
    radio_close: "إغلاق المشغّل",
    capital: "العاصمة",
    area: "المساحة",
    population: "السكان",
    currency: "العملة",
    gov_type: "نظام الحكم",
    economy: "الاقتصاد",
    borders: "الحدود",
    intro: "لمحة",
    nature: "الطبيعة",
    fauna: "الحيوان الرمز",
    mountains: "الجبال",
    rivers: "الأنهار",
    history: "التاريخ",
    guide: "دليل الزائر",
    guide_dishes: "أطباق يجب تجربتها",
    guide_cuisine: "طبق وحلوى تقليديان",
    guide_dish: "طبق",
    guide_dessert: "حلوى",
    guide_street: "أكل الشارع",
    street_of_day: "وجبة الشارع اليوم",
    guide_ingredients: "المكونات",
    recipe: "الوصفة",
    recipe_view: "عرض الوصفة",
    recipe_servings: "المقادير لأربعة أشخاص",
    recipe_prep: "التحضير",
    recipe_cook: "الطهي",
    recipe_steps: "طريقة التحضير",
    recipe_video: "شاهد فيديو الوصفة",
    recipe_video_hint: "يُفتح على يوتيوب",
    recipe_video_more: "المزيد من الفيديوهات على يوتيوب",
    cookbook: "كتاب الوصفات",
    cookbook_cta: "كتاب وصفات العالم العربي: كل الأطباق والحلويات",
    ebook: "الكتاب الإلكتروني",
    ebook_title: "ما يجب أن تعرفه عن العالم العربي",
    ebook_subtitle: "{n} دولة في كتاب واحد: مقدمة، فصل لكل دولة مع الصور والتاريخ والمطبخ ودليل السفر، وخاتمة عن العالم العربي كدولة واحدة.",
    ebook_cover_note: "اطبعه أو احفظه بصيغة PDF — أطلس العالم العربي",
    ebook_toc: "الفهرس",
    ebook_chapter: "الفصل",
    ebook_cta: "الكتاب الإلكتروني: ما يجب أن تعرفه عن العالم العربي",
    story_watch: "شاهد القصة",
    share_country_text: "اكتشف {name} على أطلس العالم العربي: تاريخ وأماكن ومطبخ وقصة بالفيديو 👇",
    story_share: "شارك القصة",
    story_share_text: "شاهدت للتو قصة {name} في 60 ثانية ✨ شاهدها أنت أيضاً:",
    paywall_app_notice: "المعاينة المجانية لهذا الكتاب متاحة في التطبيق.",
    badge_curious: "فضولي",
    badge_explorer: "مستكشف",
    badge_traveler: "رحّالة",
    badge_gourmet: "ذوّاق",
    badge_ambassador: "سفير",
    badge_sage: "حكيم العالم العربي",
    badge_next: "{n} نقطة حتى {b}",
    points_have_one: "لديك نقطة واحدة",
    paywall_bundle: "الأطلس + كتاب الوصفات بـ {price}",
    paywall_methods_play: "دفع آمن عبر Google Play",
    points_have: "لديك {n} نقطة",
    points_cost: "تحتاج {n}",
    points_redeem: "استبدل بالنقاط",
    points_how: "اكسب نقاطاً من الاختبار اليومي والقصص والعجلة والآراء: افتح شارات جواز السفر.",
    points_not_enough: "النقاط غير كافية.",
    points_title: "نقاطك",
    points_earned: "+{n} نقطة!",
    nav_intro: "المقدمة",
    nav_itineraries: "برامج الرحلات",
    nav_conclusion: "الخاتمة",
    nav_community: "المجتمع",
    itineraries_title: "رحلتك على مقاسك",
    itineraries_sub: "3 أو 5 أيام، خريطة، تنبيهات وحجوزات لـ 23 بلداً",
    points_rules: "نقطة: اختبار، قصة، عجلة · نقطتان: رأي، فوز · شارات عند 5، 15، 40، 80، 150 و300 نقطة",
    paywall_wrong_book: "هذا الرابط يفتح كتاباً إلكترونياً آخر.",
    payment_open_ebook: "افتح الكتاب الإلكتروني",
    paywall_title: "تابع القراءة",
    paywall_text: "افتح الكتاب الكامل: {n} محتوى إضافياً مع الطباعة وPDF. يبقى الفتح على هذا الجهاز وتصلك وصلة استعادة بالبريد.",
    paywall_buy: "افتح مقابل {price}",
    paywall_methods: "دفع آمن عبر Stripe · بطاقة، Google Pay، Apple Pay، PayPal",
    paywall_restore: "اشتريت من قبل؟ استعد ببريدك الإلكتروني",
    paywall_restore_button: "أرسل الرابط",
    paywall_restore_sent: "إن وُجد شراء بهذا البريد فقد أرسلنا لك رابط الاستعادة.",
    paywall_email_placeholder: "بريدك@مثال.com",
    paywall_unlocked: "تم فتح الكتاب! قراءة ممتعة.",
    paywall_invalid_link: "رابط الفتح غير صالح.",
    paywall_invalid_email: "بريد غير صالح.",
    payment_checking: "جارٍ التحقق من الدفع…",
    payment_failed: "لم يكتمل الدفع. لم يُخصم أي مبلغ.",
    payment_cancel: "تم إلغاء الدفع. يمكنك المحاولة لاحقاً.",
    nav_explore: "استكشف",
    nav_recipes: "وصفات",
    wheel_title: "عجلة البلدان",
    wheel_cta: "إلى أين تأخذك اليوم؟",
    wheel_spin: "أدر العجلة",
    wheel_sub: "أدر العجلة: بلد مفاجئ وقصته بلمسة واحدة.",
    wheel_spinning: "العجلة تدور…",
    wheel_open: "افتح البطاقة",
    wheel_again: "أدر مرة أخرى",
    cookbook_end_title: "بالهناء والشفاء!",
    cookbook_end_text: "{n} وصفة من {c} بلداً: الآن دورك. صوّر طبقك وشاركه في آراء الأطلس، أو أدر عجلة البلدان لاكتشاف المطبخ التالي.",
    story_kicker: "قصة البلد",
    story_people: "نسمة",
    story_times_italy: "{x} أضعاف مساحة إيطاليا",
    story_pct_italy: "{x}٪ من مساحة إيطاليا",
    story_cities: "أجمل الأماكن",
    story_food: "على المائدة",
    story_languages: "اللغات",
    story_climate: "المناخ",
    story_listen: "استمع",
    story_stop: "إيقاف",
    story_end_title: "هل تريد معرفة المزيد؟",
    story_end_guide: "الدليل الكامل",
    story_end_recipes: "وصفات",
    story_tap_hint: "انقر للمتابعة · اضغط مطولاً للإيقاف المؤقت",
    story_unavailable: "القصة غير متاحة بعد لهذا البلد.",
    cookbook_title: "كتاب وصفات العالم العربي",
    cookbook_subtitle: "{n} وصفة تقليدية من {c} دولة، مقادير لأربعة أشخاص، خطوة بخطوة. اطبعه أو احفظه بصيغة PDF.",
    cookbook_index: "الفهرس",
    dish_of_day: "طبق اليوم",
    dessert_of_day: "حلوى اليوم",
    recipe_print: "اطبع الوصفة",
    recipe_hours: "س",
    recipe_min: "د",
    admin_reply_label: "ردّ الأطلس",
    admin_reply_placeholder: "اكتب ردّاً عامّاً على هذا التعليق…",
    admin_reply_save: "نشر الردّ",
    admin_reply_remove: "حذف الردّ",
    admin_reply_saved: "تم نشر الردّ",
    admin_stats: "الإحصاءات",
    admin_stats_push: "المشتركون في الإشعارات",
    admin_stats_players: "لاعبو هذا الأسبوع",
    admin_stats_games: "تحديات أُنجزت هذا الأسبوع",
    admin_stats_perfect: "نتائج كاملة (5/5)",
    admin_stats_all_players: "إجمالي اللاعبين",
    admin_stats_pending: "تعليقات بانتظار المراجعة",
    admin_stats_approved: "تعليقات منشورة",
    guide_places: "أماكن لا تُفوَّت",
    guide_best_time: "أفضل وقت للزيارة",
    guide_getting_around: "التنقل في البلد",
    guide_tip: "نصيحة",
    guide_itinerary: "اقتراح برنامج 5 أيام",
    day: "اليوم",
    privacy: "سياسة الخصوصية",
    favorites: "المفضلة",
    add_favorite: "أضف إلى المفضلة",
    remove_favorite: "إزالة من المفضلة",
    print_pdf: "طباعة / حفظ PDF",
    download_guide: "تنزيل الدليل (PDF)",
    back: "رجوع",
    reviews: "آراء الزوار",
    gallery: "صور الزوار",
    song_label: "الأغنية الأشهر",
    song_classic: "كلاسيكية",
    listen_full: "استمع إلى الأغنية كاملة",
    preview_note: "مقطع تجريبي 30 ثانية",
    song_modern: "حديثة",
    song_play: "تشغيل",
    song_pause: "إيقاف مؤقت",
    music_on: "تشغيل الموسيقى تلقائياً",
    music_off: "إيقاف الموسيقى التلقائية",
    review_add_photo: "أضف صورة",
    review_add_media: "أضف صورة أو فيديو",
    review_media_hint: "صورة (JPG/PNG حتى 5 م.ب) أو فيديو (حتى 30 ثانية، 50 م.ب). يُحذف تلقائياً بعد 6 أشهر.",
    review_video_too_long: "الفيديو طويل جداً: الحد الأقصى 30 ثانية.",
    review_video_too_big: "الفيديو كبير جداً: الحد الأقصى 50 ميغابايت.",
    review_photo_too_big: "الصورة كبيرة جداً: الحد الأقصى 5 ميغابايت.",
    review_uploading: "جارٍ الرفع…",
    video_gallery: "فيديوهات الزوار",
    like: "أعجبني",
    unlike: "إلغاء الإعجاب",
    sorted_by_likes: "الأكثر إعجاباً أولاً",
    top_media: "الصور والفيديوهات الأكثر إعجاباً",
    photographer_badge: "مصوّر الأطلس",
    media_share: "شارك الصورة",
    media_share_text: "شاهد ذكرى سفر {author} من {country} في أطلس العالم العربي 📸",
    latest_reviews: "أحدث التعليقات",
    postcard: "بطاقة بريدية",
    postcard_sub: "صورة الزائر في بطاقة بريدية رقمية مع العلم وتحية — نزّلها أو أرسلها إلى أصدقائك.",
    postcard_download: "تنزيل البطاقة (PNG)",
    postcard_text: "تحيات من {country} 🌍 بطاقة بريدية من أطلس العالم العربي",
    memories_legend: "ذكريات الزوار",
    memories_tooltip: "{n} من ذكريات الزوار",
    live: "مباشر",
    photographer_badge_hint: "صاحب الصورة أو الفيديو الأكثر إعجاباً هذا الشهر",
    review_photo_hint: "صورة من رحلتك (JPG/PNG، حتى 5 ميغابايت). تُحذف تلقائياً بعد 6 أشهر.",
    review_photo_remove: "إزالة الصورة",
    top_rated: "الأعلى تقييماً من الزوار",
    review_none: "لا توجد تقييمات بعد — كن أول من يشارك رأيه!",
    review_write: "قيّم هذه الدولة",
    review_edit: "عدّل تقييمك",
    review_placeholder: "شارك تجربتك: ماذا أعجبك؟ نصيحة للزوار؟",
    review_send: "إرسال",
    review_pending: "في انتظار الموافقة",
    review_login: "سجّل الدخول بحساب Google لكتابة تعليق أو رفع صورة أو فيديو",
    media_cta: "اترك تعليقاً أو صورة أو فيديو",
    review_name_placeholder: "اسمك (مثال: أحمد من القاهرة)",
    review_email_placeholder: "البريد الإلكتروني (اختياري)",
    review_email_hint: "البريد الإلكتروني لا يُنشر أبداً: نستخدمه فقط لإعلامك عندما تصل صورتك إلى 10 إعجابات.",
    review_name_required: "اكتب اسمك من فضلك",
    media_pick: "أضف صورة أو فيديو (اختياري)",
    media_cta_sub: "قيّم الدولة واحكِ عن رحلتك: نص أو صورة أو فيديو حتى 30 ثانية. بدون تسجيل.",
    review_pick_rating: "اختر عدد النجوم",
    review_error: "حدث خطأ، حاول مرة أخرى",
    logout: "تسجيل الخروج",
    admin_title: "إدارة التعليقات",
    admin_forbidden: "هذه الصفحة للمشرف فقط",
    admin_empty: "لا توجد تعليقات هنا",
    moderation: "الإشراف",
    status_pending: "بانتظار الموافقة",
    status_approved: "منشورة",
    status_rejected: "مرفوضة",
    photo_wiki: "صورة: ويكيميديا",
    demographics: "السكان والمدن",
    age_distribution: "التوزيع العمري",
    largest_city: "أكبر مدينة",
    inhabitants: "نسمة",
    age_0_14: "0–14 سنة",
    age_15_29: "15–29 سنة",
    age_30_59: "30–59 سنة",
    age_60plus: "60+ سنة",
    source_wb: "المصدر: البنك الدولي",
    independence: "الاستقلال",
    industrial_city: "المدينة الصناعية",
    religious_city: "المدينة الدينية",
    historical_note: "لمحة تاريخية",
    prev: "السابق",
    next: "التالي",
    close: "إغلاق",
    disputed: "إقليم متنازع عليه",
    no_borders: "لا حدود برية",
    km2: "كم²",
    people: "نسمة",
    million: "مليون",
    quiz_intro: "خمّن الدولة من علمها",
    quiz_score: "النتيجة",
    quiz_next: "التالي",
    quiz_correct: "إجابة صحيحة!",
    quiz_wrong: "الإجابة الصحيحة:",
    compare_pick: "اختر دولتين للمقارنة",
    compare_country_a: "الدولة الأولى",
    compare_country_b: "الدولة الثانية",
    reset: "إعادة",
    language: "اللغة",
    footer: "أطلس تعليمي مبسّط. البيانات إرشادية.",
    no_results: "لا نتائج",
    home: "الرئيسية",
    open_menu: "القائمة",
    kbd_hint: "← → للتنقل، / للبحث، Esc للإغلاق",
    random: "دولة عشوائية",
    recent: "شوهدت مؤخراً",
    share: "شارك هذه الدولة",
    share_app: "شارك التطبيق",
    share_app_text: "اكتشف أطلس العالم العربي التفاعلي: 22 دولة، خرائط، أعلام، تاريخ واختبارات 🌍",
    copied: "تم نسخ الرابط",
    badge_champion: "بطل الأسبوع",
    champion_req: "افز بلوحة صدارة التحدي الأسبوعية (الاثنين→الأحد)",
    champion_won: "فزت بلوحة الصدارة بـ {total} نقطة. يصلك إشعار كل اثنين تفوز فيه!",
    lb_last_champion: "بطل الأسبوع الماضي: {nick} بـ {total} نقطة",
    vs_create: "تحدَّ صديقاً",
    vs_rematch: "أعد التحدي",
    vs_ready: "الرابط جاهز: من يفتحه يلعب نفس أسئلتك الخمسة",
    vs_share_text: "حققت {score} في تحدي الأطلس #{n} — هل تستطيع التفوق عليّ؟",
    vs_anon: "صديق",
    vs_banner: "تحداك {name}",
    vs_yours: "تحديك لليوم",
    vs_expired: "انتهى التحدي: العب تحدي اليوم!",
    vs_missing: "التحدي غير موجود: العب تحدي اليوم!",
    vs_you: "أنت",
    vs_win: "فزت! تفوقت على {name}",
    vs_draw: "تعادل مع {name}",
    vs_lose: "فاز {name}… الثأر غداً!",
    vs_stats: "{n} أصدقاء قبلوا تحديك، {k} تفوقوا عليك",
    push_cta: "ذكّرني كل يوم الساعة 9",
    push_on: "التذكير مفعّل",
    push_denied: "الإشعارات محظورة في المتصفح",
    push_hint: "استلم دولة اليوم والتحدي الجديد الساعة 9:00",
    push_off_hint: "اضغط لإيقاف التذكير",
    nick_title: "ادخل لوحة الصدارة باسم مستعار",
    nick_placeholder: "اسمك المستعار",
    nick_save: "حفظ",
    nick_hint: "2-20 حرفاً، أحرف وأرقام. نتيجة واحدة يومياً لكل جهاز.",
    nick_invalid: "اسم مستعار غير صالح",
    nick_saved: "تم حفظ النتيجة باسم {nick}",
    lb_title: "لوحة صدارة الأسبوع",
    lb_sub: "من الاثنين إلى الأحد: مجموع نقاط التحديات اليومية. تُصفَّر كل اثنين.",
    lb_players: "{n} لاعبين",
    country_of_day: "دولة اليوم",
    daily_challenge: "تحدي اليوم",
    daily_cta: "العب الآن",
    daily_sub: "5 أسئلة، نفسها للجميع، مرة واحدة يومياً",
    daily_done_hint: "عد غداً للتحدي التالي",
    daily_streak: "السلسلة: {n} أيام",
    daily_streak_one: "السلسلة: يوم واحد",
    daily_q_capital: "أي دولة عاصمتها هذه؟",
    daily_q_fauna: "أي دولة حيوانها الرمز هذا؟",
    daily_q_currency: "أي دولة تستخدم هذه العملة؟",
    daily_q_region: "أي دولة تنتمي إلى هذه المنطقة الكبرى؟",
    intro_read_more: "اقرأ المقدمة كاملة",
    daily_finish: "اعرض النتيجة",
    daily_share: "تحدي الأطلس #{n}: {score}",
    daily_come_back: "تحدٍ جديد كل يوم عند منتصف الليل. شارك نتيجتك وتحدَّ أصدقاءك!",
    quiz_practice: "تدريب",
    passport: "جواز سفر الأطلس",
    passport_kicker: "رحلتك",
    passport_intro: "كل دولة تفتحها تحصل على ختم. اجمعها كلها وافتح الشارات.",
    passport_next: "بقي {n} لشارة {badge}",
    passport_complete: "لقد زرت العالم العربي كله!",
    passport_current: "الشارة الحالية:",
    passport_start: "افتح دولة للحصول على أول ختم",
    passport_explore: "استكشف الخريطة",
    passport_share: "جواز سفر الأطلس الخاص بي: {n}/{total} دولة، شارة {badge} 🛂",
    badges: "الشارات",
    badge_req: "{n} دولة تمت زيارتها",
    badge_explorer: "مستكشف",
    badge_traveller: "رحّالة",
    badge_connoisseur: "خبير",
    badge_master: "سيّد الأطلس",
    badge_none: "لا شيء",
    badge_unlocked: "شارة جديدة:",
    stamp_new: "ختم جديد: {country} 🛂",
    install_title: "ثبّت أطلس العالم العربي",
    install_text: "أضفه إلى شاشتك الرئيسية: يفتح بملء الشاشة ويعمل دون اتصال.",
    install_action: "تثبيت التطبيق",
    install_ios_hint: "في Safari اضغط زر المشاركة ثم:",
    install_ios_action: "إضافة إلى الشاشة الرئيسية",
  },
  en: {
    kit_tab_phrases: "Phrases",
    kit_tab_packing: "Packing",
    phrases_search: "Search a phrase…",
    phrases_play: "Hear the pronunciation",
    phrases_voice_hint: "For offline audio install an Arabic voice in your phone settings (Text-to-speech).",
    pack_docs: "Documents & money",
    pack_clothes: "Clothes",
    pack_health: "Health",
    pack_tech: "Tech",
    pack_extra: "Useful extras",
    packing_reset: "Reset",
    diary_title: "Travel diary",
    diary_visited: "Mark as visited",
    diary_complete_title: "Trip to {country} completed!",
    diary_complete_desc: "You earned the Diary stamp in your Passport and +5 points",
    badge_diary: "Travel diary",
    diary_badge_req: "Tick every stop of an itinerary to get the stamp",
    diary_badge_done: "{n} trips completed with every stop",
    diary_badge_done_one: "1 trip completed with every stop",
    guess_by: "{name}'s challenge",
    guess_counter: "Create your challenge",
    guess_board_title: "Challenge leaderboard",
    guess_board_sub: "3 points for a first-try guess, 2 for the second, 1 for the third · {n} players",
    guess_name_placeholder: "Your leaderboard name",
    guess_name_saved: "Name saved",
    guess_you: "you",
    album_title: "Travel album",
    album_add: "Add a photo to this stop",
    album_added: "Photo added to the album",
    group_title: "Travel buddies",
    group_btn: "Buddies",
    group_sub: "Create a code for {country} or enter a friend's: you'll share the same itinerary and see who ticked what.",
    group_sub_active: "The group follows the {country} itinerary. Ticks update automatically.",
    group_name_placeholder: "Your name in the group",
    group_create: "Create a group code",
    group_or: "or",
    group_join: "Join",
    group_hint: "No sign-up: the group lives 60 days, then deletes itself.",
    group_code_label: "Group code",
    group_invite: "Invite",
    group_copy: "Copy",
    group_share_text: "Travel with me! Enter code {code} in the Atlas of the Arab World and let's follow the same itinerary ✈️",
    group_progress: "The group has visited {n} of {total} stops",
    group_members_hint: "{n} in the group · refreshes every 20 seconds",
    group_you: "you",
    group_leave: "Leave the group",
    group_left: "You left the group",
    group_joined: "You're in group {code}",
    group_not_found: "Code not found or expired",
    group_full: "The group is full (20 people)",
    group_other_country: "Your group {code} follows the {country} itinerary.",
    group_open_trip: "Open the group itinerary",
    group_seen_by: "Visited by {names}",
    loc_btn: "Use my location",
    loc_hint: "Only when you tap: your location never leaves your phone",
    loc_found: "You're in {country}: country and SOS numbers set",
    loc_far: "You're {km} km from {country}: use it?",
    loc_use: "Use",
    receipt_title: "Want the receipt by e-mail?",
    receipt_sub: "We'll send the purchase confirmation with the link to open the e-book on another device too. Optional.",
    receipt_send: "Send",
    receipt_skip: "No, thanks",
    receipt_sent: "Receipt sent to {email}",
    receipt_privacy: "The e-mail is used only for the receipt and to restore the purchase; you can delete it from Delete my data.",
    status_play: "Play Store",
    report_resolved: "Thank you: the content you reported has been removed by the team",
    report_btn: "Report",
    report_title: "Report this content",
    report_sub: "Tell us why: the team reviews it as soon as possible. After 3 reports the content is suspended immediately.",
    report_spam: "Spam or advertising",
    report_offensive: "Hate, insults or harassment",
    report_inappropriate: "Explicit or violent content",
    report_copyright: "Copyright violation",
    report_privacy: "Personal data or photo without consent",
    report_other: "Other",
    report_note: "Details (optional)",
    report_send: "Send report",
    report_sent: "Thanks, report sent to the team",
    report_error: "Could not send, please retry",
    report_hint: "Reports are anonymous: we only keep the device identifier to avoid duplicates.",
    hide_author: "Hide content from {name}",
    hide_done: "You won't see content from {name} on this device any more",
    rules_title: "Community rules",
    rules_accept: "By posting I accept the {rules} and confirm I am at least 13 years old.",
    rules_required: "You must accept the community rules to post",
    status_reported: "Reported",
    admin_reports_clear: "Dismiss reports",
    admin_suspended: "suspended",
    reward_btn: "Watch a video → +{n} points",
    reward_title: "Reward video",
    reward_sub: "Watch a short ad to the end and get +{n} points towards your badges (up to 3 times a day).",
    reward_disclosure: "It's optional. Points only unlock badges in the Passport, have no cash value and cannot be converted. The reward is granted by the Atlas, not by Google.",
    reward_yes: "Watch the ad",
    reward_no: "No, thanks",
    reward_none: "No ad available right now, try again later",
    arrival_title: "Have you arrived in {country}?",
    arrival_desc: "SOS numbers, currency and useful phrases are ready in the Travel Kit.",
    arrival_cta: "Open the SOS Kit",
    loc_found_dest: "Destination set: {country}",
    loc_denied: "Location permission denied: pick the country from the flags",
    loc_unavailable: "Location unavailable: pick the country from the flags",
    album_card: "Memory postcard",
    album_card_sub: "{name}'s trip · {n} days",
    album_share_text: "My travel album in {country} 📸 made with the Atlas of the Arab World",
    album_saved: "Postcard saved to your phone",
    album_private: "Photos stay on your phone only: they are never uploaded.",
    delete: "Delete",
    story_ambience: "Ambient sounds (souq, desert, sea)",
    save: "Save",
    guess_board_empty: "No players yet — be the first!",
    kit_title: "Travel Kit",
    kit_sub: "SOS, currency and translator — offline too",
    kit_offline_mode: "You're offline: data saved on your phone",
    kit_offline_empty: "Open this page once while online to save the data for offline use.",
    kit_tab_sos: "SOS",
    kit_tab_currency: "Currency",
    kit_tab_camera: "Translator",
    kit_embassy: "Find your embassy on Google Maps",
    kit_embassy_query: "embassy",
    kit_fx_flip: "Swap",
    kit_fx_live: "rate updated today",
    kit_fx_cached: "last saved rate (offline)",
    kit_cam_cta: "Photograph a menu or a sign",
    kit_cam_hint: "Reads Arabic right on your phone; the translation arrives when you're online",
    kit_cam_reading: "Reading text…",
    kit_cam_translating: "Translating…",
    kit_cam_original: "Text found",
    kit_cam_translation: "Translation",
    kit_cam_nothing: "No readable text found: get closer and try again with more light.",
    kit_cam_offline: "Text read, but translation needs a connection.",
    kit_cam_error: "Reading failed, please try again.",
    postcard_trip: "Postcard",
    guess_challenge: "Challenge friends",
    guess_share_text: "Can you guess my next destination? 🧭 3 tries, 23 flags:",
    guess_title: "Guess the destination",
    guess_sub: "Read the stops and pick the right country. Tries left: {n}",
    guess_more_hints: "Each wrong try reveals another day.",
    guess_won: "Guessed on try {n}! +2 bonus points and {p} on the leaderboard",
    guess_lost: "Not this time! The destination was…",
    guess_wrong: "Nope… try again",
    guess_open_trip: "Open the itinerary",
    guess_missing: "Invalid link: ask your friend to share the challenge again.",
    ob_intro: "Five quick steps and we build your colourful day-by-day trip plan.",
    ob_step: "Step {n} of {total}",
    ob_name_title: "What's your name?",
    ob_name_placeholder: "Your name…",
    ob_origin_title: "Where are you travelling from, {name}?",
    ob_origin_hint: "Used to set the map language and the currency of hotel and flight prices.",
    ob_dest_title: "Where do you want to go?",
    ob_days_title: "How many days?",
    ob_days_short: "Short trip: one city and its surroundings",
    ob_days_medium: "Medium trip: two cities or regions",
    ob_interests_title: "What excites you most?",
    ob_next: "Next",
    ob_create: "Build my plan",
    ob_skip: "Skip",
    interest_culture: "Culture & History",
    interest_adventure: "Adventure & Desert",
    interest_shopping: "Shopping & Modernity",
    style_culture: "Keeper of the Medinas",
    style_adventure: "Desert Nomad",
    style_shopping: "Souq Hunter",
    style_culture_adventure: "Ancient Explorer",
    style_culture_shopping: "City Connoisseur",
    style_adventure_shopping: "Modern Adventurer",
    style_culture_adventure_shopping: "Total Traveller",
    trip_style_hint: "That's your travel style! Share it with friends.",
    trip_hello: "Hi {name} 👋",
    trip_sub: "Your {n}-day plan for {country}",
    trip_edit: "Edit",
    trip_share: "Share my trip",
    trip_share_text: "My {n}-day trip to {country} ✈️ — free plan with map and SOS numbers:",
    trip_for_you: "Matches your interests",
    days_short: "days",
    tab_map: "Map",
    tab_warnings: "Alerts & dress",
    tab_food: "Food",
    tab_book: "Book",
    trip_open_maps: "Open route in Google Maps",
    trip_map_unavailable: "Map not available here — open the route in Google Maps.",
    dress_relaxed: "Relaxed dress",
    dress_moderate: "Modest dress",
    dress_strict: "Conservative dress",
    sos_title: "Emergency numbers (work offline)",
    sos_unified: "Unified number",
    sos_police: "Police",
    sos_ambulance: "Ambulance",
    sos_fire: "Fire",
    sos_tourist_police: "Tourist police",
    trip_upsell: "Want to cook these recipes at home? Unlock the full Cookbook for just €0.99",
    trip_upsell_neutral: "Want to cook these recipes at home? Discover the Cookbook",
    book_hotels: "Hotels in {city}",
    book_compare: "Compare hotel prices",
    book_flights: "Flights",
    book_tours: "Tours & experiences in {city}",
    book_tickets: "Museum & attraction tickets",
    book_partner: "partner link",
    book_disclosure: "Partner links: if you book through them the Atlas earns a small commission at no extra cost to you. They open in your browser.",
    app_title: "Arab World Atlas",
    app_tagline: "An interactive map of the Arab League",
    search_placeholder: "Search a country…",
    alphabet_menu: "Alphabetical index",
    all_countries: "All countries",
    map: "Map",
    quiz: "Quiz",
    compare: "Compare",
    radio: "Radio",
    radio_title: "Atlas Radio",
    radio_tagline: "{n} songs from the Arab world, classic and modern — play them in a row or shuffle.",
    radio_all: "All",
    overview_kicker: "Conclusion",
    overview_cta: "The Arab World as a single country",
    overview_sub: "History, people and economy together, compared with the EU and the USA",
    radio_share: "Share this song",
    radio_share_text: "Listen to \"{title}\" by {artist} ({country}) on Atlas Radio 🎵",
    radio_open: "Open Atlas Radio",
    radio_close: "Close player",
    capital: "Capital",
    area: "Area",
    population: "Population",
    currency: "Currency",
    gov_type: "Government",
    economy: "Economy",
    borders: "Borders",
    intro: "Overview",
    nature: "Nature",
    fauna: "Symbolic fauna",
    mountains: "Mountains",
    rivers: "Rivers",
    history: "History",
    guide: "Visitor guide",
    guide_dishes: "Dishes to try",
    guide_cuisine: "Signature dish & dessert",
    guide_dish: "Dish",
    guide_dessert: "Dessert",
    guide_street: "Street food",
    street_of_day: "Street food of the day",
    guide_ingredients: "Ingredients",
    recipe: "Recipe",
    recipe_view: "See the recipe",
    recipe_servings: "Serves 4",
    recipe_prep: "Prep",
    recipe_cook: "Cooking",
    recipe_steps: "Method",
    recipe_video: "Watch the video recipe",
    recipe_video_hint: "Opens on YouTube",
    recipe_video_more: "More videos on YouTube",
    cookbook: "Cookbook",
    cookbook_cta: "Arab World Cookbook: all the dishes and desserts",
    ebook: "E-book",
    ebook_title: "What you need to know about the Arab world",
    ebook_subtitle: "{n} countries in one book: an introduction, a chapter per country with photos, history, cuisine and travel guide, and a conclusion on the Arab world as a single country.",
    ebook_cover_note: "Print it or save it as PDF — Atlas of the Arab World",
    ebook_toc: "Contents",
    ebook_chapter: "Chapter",
    ebook_cta: "E-book: what you need to know about the Arab world",
    story_watch: "Watch the Story",
    share_country_text: "Discover {name} on the Atlas of the Arab World: history, places, food and the video Story 👇",
    story_share: "Share the Story",
    story_share_text: "I just watched the 60-second Story of {name} ✨ Watch it too:",
    paywall_app_notice: "The free preview of this e-book is available in the app.",
    badge_curious: "Curious",
    badge_explorer: "Explorer",
    badge_traveler: "Traveller",
    badge_gourmet: "Gourmet",
    badge_ambassador: "Ambassador",
    badge_sage: "Sage of the Arab World",
    badge_next: "{n} points to {b}",
    points_have_one: "You have 1 point",
    paywall_bundle: "Atlas + Cookbook for {price}",
    paywall_methods_play: "Secure payment with Google Play",
    points_have: "You have {n} points",
    points_cost: "{n} needed",
    points_redeem: "Redeem with points",
    points_how: "Earn points with the daily quiz, Stories, the Wheel and reviews: unlock Passport badges.",
    points_not_enough: "Not enough points.",
    points_title: "Your points",
    points_earned: "+{n} points!",
    nav_intro: "Introduction",
    nav_itineraries: "Itineraries",
    nav_conclusion: "Conclusion",
    nav_community: "Community",
    itineraries_title: "Your tailor-made trip",
    itineraries_sub: "3 or 5 days, map, alerts and bookings for 23 countries",
    points_rules: "1 point: quiz, Story, Wheel · 2 points: review, quiz won · badges at 5, 15, 40, 80, 150 and 300 points",
    paywall_wrong_book: "This link unlocks a different e-book.",
    payment_open_ebook: "Open the e-book",
    paywall_title: "Keep reading",
    paywall_text: "Unlock the full e-book: {n} more items, print and PDF included. The unlock stays on this device and you get a restore link by email.",
    paywall_buy: "Unlock for {price}",
    paywall_methods: "Secure payment with Stripe · card, Google Pay, Apple Pay, PayPal",
    paywall_restore: "Already purchased? Restore with your email",
    paywall_restore_button: "Send link",
    paywall_restore_sent: "If a purchase exists for this email, we've sent you the restore link.",
    paywall_email_placeholder: "your@email.com",
    paywall_unlocked: "E-book unlocked! Enjoy.",
    paywall_invalid_link: "Invalid unlock link.",
    paywall_invalid_email: "Invalid email.",
    payment_checking: "Checking your payment…",
    payment_failed: "Payment not completed. Nothing was charged.",
    payment_cancel: "Payment cancelled. You can try again anytime.",
    nav_explore: "Explore",
    nav_recipes: "Recipes",
    wheel_title: "Country Wheel",
    wheel_cta: "Where will it take you today?",
    wheel_sub: "Spin the wheel: a surprise country and its Story in one tap.",
    wheel_spin: "Spin the wheel",
    wheel_spinning: "Spinning…",
    wheel_open: "Open the sheet",
    wheel_again: "Spin again",
    cookbook_end_title: "Enjoy your meal!",
    cookbook_end_text: "{n} recipes from {c} countries: now it's your turn. Photograph your dish and share it in the Atlas reviews, or spin the Country Wheel to discover the next cuisine.",
    story_kicker: "Country Story",
    story_people: "inhabitants",
    story_times_italy: "{x} times Italy",
    story_pct_italy: "{x}% of Italy",
    story_cities: "Most beautiful places",
    story_food: "At the table",
    story_languages: "Languages",
    story_climate: "Climate",
    story_listen: "Listen",
    story_stop: "Stop",
    story_end_title: "Want to know more?",
    story_end_guide: "Full guide",
    story_end_recipes: "Recipes",
    story_tap_hint: "Tap to advance · hold to pause",
    story_unavailable: "Story not yet available for this country.",
    cookbook_title: "Arab World Cookbook",
    cookbook_subtitle: "{n} traditional recipes from {c} countries, serving 4, step by step. Print it or save it as PDF.",
    cookbook_index: "Contents",
    dish_of_day: "Dish of the day",
    dessert_of_day: "Dessert of the day",
    recipe_print: "Print the recipe",
    recipe_hours: "h",
    recipe_min: "min",
    admin_reply_label: "Reply from the Atlas",
    admin_reply_placeholder: "Write a public reply to this comment…",
    admin_reply_save: "Publish reply",
    admin_reply_remove: "Remove reply",
    admin_reply_saved: "Reply published",
    admin_stats: "Statistics",
    admin_stats_push: "Notification subscribers",
    admin_stats_players: "Players this week",
    admin_stats_games: "Challenges played this week",
    admin_stats_perfect: "Perfect scores (5/5)",
    admin_stats_all_players: "All-time players",
    admin_stats_pending: "Comments awaiting review",
    admin_stats_approved: "Published comments",
    guide_places: "Must-see places",
    guide_best_time: "Best time to visit",
    guide_getting_around: "Getting around",
    guide_tip: "Tip",
    guide_itinerary: "Suggested 5-day itinerary",
    day: "Day",
    privacy: "Privacy policy",
    favorites: "Favourites",
    add_favorite: "Add to favourites",
    remove_favorite: "Remove from favourites",
    print_pdf: "Print / Save as PDF",
    download_guide: "Download guide (PDF)",
    back: "Back",
    reviews: "Visitor reviews",
    gallery: "Visitor photos",
    song_label: "Iconic song",
    song_classic: "Classic",
    listen_full: "Listen to the full song",
    preview_note: "30-second preview",
    song_modern: "Modern",
    song_play: "Play",
    song_pause: "Pause",
    music_on: "Turn auto-play music on",
    music_off: "Turn auto-play music off",
    review_add_photo: "Add a photo",
    review_add_media: "Add a photo or video",
    review_media_hint: "A photo (JPG/PNG, max 5 MB) or a video (max 30 s, 50 MB). Automatically deleted after 6 months.",
    review_video_too_long: "Video too long: 30 seconds max.",
    review_video_too_big: "Video too large: 50 MB max.",
    review_photo_too_big: "Photo too large: 5 MB max.",
    review_uploading: "Uploading…",
    video_gallery: "Visitor videos",
    like: "Like",
    unlike: "Unlike",
    sorted_by_likes: "most liked first",
    top_media: "Most loved photos & videos",
    photographer_badge: "Atlas Photographer",
    media_share: "Share this photo",
    media_share_text: "Check out {author}'s travel memory from {country} on the Arab World Atlas 📸",
    latest_reviews: "Latest comments",
    postcard: "Postcard",
    postcard_sub: "The visitor's photo as a digital postcard with flag and greeting — download it or send it to friends.",
    postcard_download: "Download postcard (PNG)",
    postcard_text: "Greetings from {country} 🌍 A postcard from the Arab World Atlas",
    memories_legend: "Visitor memories",
    memories_tooltip: "{n} visitor memories",
    live: "live",
    photographer_badge_hint: "Author of the most liked photo or video this month",
    review_photo_hint: "A photo from your trip (JPG/PNG, max 5 MB). Automatically deleted after 6 months.",
    review_photo_remove: "Remove photo",
    top_rated: "Top rated by visitors",
    review_none: "No reviews yet — be the first to share!",
    review_write: "Rate this country",
    review_edit: "Edit your review",
    review_placeholder: "Share your experience: what did you love? Any tips?",
    review_send: "Send",
    review_pending: "Awaiting approval",
    review_login: "Sign in with Google to leave a review, a photo or a video",
    media_cta: "Leave a comment, a photo or a video",
    review_name_placeholder: "Your name (e.g. Sarah from London)",
    review_email_placeholder: "Email (optional)",
    review_email_hint: "Your email is never published: we only use it to tell you when your photo reaches 10 likes.",
    review_name_required: "Please enter your name",
    media_pick: "Add a photo or video (optional)",
    media_cta_sub: "Rate the country and tell us about your trip: text, a photo or a 30-second video. No sign-up needed.",
    review_pick_rating: "Pick a star rating",
    review_error: "Something went wrong, please retry",
    logout: "Sign out",
    admin_title: "Review moderation",
    admin_forbidden: "This page is for the administrator only",
    admin_empty: "Nothing here",
    moderation: "Moderation",
    status_pending: "Pending",
    status_approved: "Published",
    status_rejected: "Rejected",
    photo_wiki: "Photo: Wikimedia",
    demographics: "People & cities",
    age_distribution: "Age distribution",
    largest_city: "Largest city",
    inhabitants: "inhabitants",
    age_0_14: "0–14 yrs",
    age_15_29: "15–29 yrs",
    age_30_59: "30–59 yrs",
    age_60plus: "60+ yrs",
    source_wb: "Source: World Bank",
    independence: "Independence",
    industrial_city: "Industrial city",
    religious_city: "Religious city",
    historical_note: "Historical note",
    prev: "Prev",
    next: "Next",
    close: "Close",
    disputed: "Disputed territory",
    no_borders: "No land borders",
    km2: "km²",
    people: "people",
    million: "M",
    quiz_intro: "Guess the country from its flag",
    quiz_score: "Score",
    quiz_next: "Next",
    quiz_correct: "Correct!",
    quiz_wrong: "Correct answer:",
    compare_pick: "Pick two countries to compare",
    compare_country_a: "Country A",
    compare_country_b: "Country B",
    reset: "Reset",
    language: "Language",
    footer: "A simplified educational atlas. Data is indicative.",
    no_results: "No results",
    home: "Home",
    open_menu: "Menu",
    kbd_hint: "← → to navigate, / to search, Esc to close",
    random: "Random country",
    recent: "Recently viewed",
    share: "Share this country",
    share_app: "Share the app",
    share_app_text: "Discover the Interactive Arab World Atlas: 22 countries, maps, flags, history and quizzes 🌍",
    copied: "Link copied",
    badge_champion: "Champion of the week",
    champion_req: "Win the weekly Challenge leaderboard (Monday→Sunday)",
    champion_won: "You won the leaderboard with {total} points. You get a notification every Monday you win!",
    lb_last_champion: "Last week's champion: {nick} with {total} points",
    vs_create: "Challenge a friend",
    vs_rematch: "Challenge back",
    vs_ready: "Link ready: whoever opens it plays your same 5 questions",
    vs_share_text: "I scored {score} in Atlas Challenge #{n} — can you beat me?",
    vs_anon: "A friend",
    vs_banner: "{name} challenged you",
    vs_yours: "Your challenge of the day",
    vs_expired: "Challenge expired: play today's!",
    vs_missing: "Challenge not found: play today's!",
    vs_you: "You",
    vs_win: "You won! You beat {name}",
    vs_draw: "Draw with {name}",
    vs_lose: "{name} won… rematch tomorrow!",
    vs_stats: "{n} friends accepted your challenge, {k} beat you",
    push_cta: "Remind me every day at 9",
    push_on: "Reminder on",
    push_denied: "Notifications blocked in the browser",
    push_hint: "Get the country of the day and the new challenge at 9:00",
    push_off_hint: "Tap to turn the reminder off",
    nick_title: "Join the leaderboard with a nickname",
    nick_placeholder: "Your nickname",
    nick_save: "Save",
    nick_hint: "2-20 characters, letters and numbers. One score per day per device.",
    nick_invalid: "Invalid nickname",
    nick_saved: "Score saved as {nick}",
    lb_title: "This week's leaderboard",
    lb_sub: "Monday to Sunday: sum of your daily challenge points. Resets every Monday.",
    lb_players: "{n} players",
    country_of_day: "Country of the day",
    daily_challenge: "Daily Challenge",
    daily_cta: "Play now",
    daily_sub: "5 questions, the same for everyone, once a day",
    daily_done_hint: "Come back tomorrow for the next challenge",
    daily_streak: "Streak: {n} days",
    daily_streak_one: "Streak: 1 day",
    daily_q_capital: "Which country has this capital?",
    daily_q_fauna: "Which country has this symbolic animal?",
    daily_q_currency: "Which country uses this currency?",
    daily_q_region: "Which country belongs to this macro-region?",
    intro_read_more: "Read the full introduction",
    daily_finish: "See your result",
    daily_share: "Atlas Challenge #{n}: {score}",
    daily_come_back: "A new challenge every day at midnight. Share your result and challenge your friends!",
    quiz_practice: "Practice",
    passport: "Atlas Passport",
    passport_kicker: "Your journey",
    passport_intro: "Every country you open gets a stamp. Collect them all and unlock badges.",
    passport_next: "{n} more for the {badge} badge",
    passport_complete: "You have visited the whole Arab world!",
    passport_current: "Current badge:",
    passport_start: "Open a country to get your first stamp",
    passport_explore: "Explore the map",
    passport_share: "My Atlas Passport: {n}/{total} countries, {badge} badge 🛂",
    badges: "Badges",
    badge_req: "{n} countries visited",
    badge_explorer: "Explorer",
    badge_traveller: "Traveller",
    badge_connoisseur: "Connoisseur",
    badge_master: "Atlas Master",
    badge_none: "none",
    badge_unlocked: "New badge:",
    stamp_new: "New stamp: {country} 🛂",
    install_title: "Install the Arab World Atlas",
    install_text: "Add it to your home screen: opens full-screen and works offline.",
    install_action: "Install app",
    install_ios_hint: "In Safari tap the Share button, then:",
    install_ios_action: "Add to Home Screen",
  },
  it: {
    kit_tab_phrases: "Frasi",
    kit_tab_packing: "Valigia",
    phrases_search: "Cerca una frase…",
    phrases_play: "Ascolta la pronuncia",
    phrases_voice_hint: "Per l'audio offline installa la voce araba nelle impostazioni del telefono (Sintesi vocale).",
    pack_docs: "Documenti e soldi",
    pack_clothes: "Abbigliamento",
    pack_health: "Salute",
    pack_tech: "Tecnologia",
    pack_extra: "Extra utili",
    packing_reset: "Azzera",
    diary_title: "Diario di viaggio",
    diary_visited: "Segna come visitata",
    diary_complete_title: "Viaggio in {country} completato!",
    diary_complete_desc: "Hai guadagnato il timbro Diario nel Passaporto e +5 punti",
    badge_diary: "Diario di viaggio",
    diary_badge_req: "Spunta tutte le tappe di un itinerario per ricevere il timbro",
    diary_badge_done: "{n} viaggi completati con tutte le tappe",
    diary_badge_done_one: "1 viaggio completato con tutte le tappe",
    guess_by: "Sfida di {name}",
    guess_counter: "Crea la tua sfida",
    guess_board_title: "Classifica sfide",
    guess_board_sub: "3 punti se indovini al primo colpo, 2 al secondo, 1 al terzo · {n} giocatori",
    guess_name_placeholder: "Il tuo nome in classifica",
    guess_name_saved: "Nome salvato",
    guess_you: "tu",
    album_title: "Album di viaggio",
    album_add: "Aggiungi una foto a questa tappa",
    album_added: "Foto aggiunta all'album",
    group_title: "Amici in viaggio",
    group_btn: "Amici",
    group_sub: "Crea un codice per {country} o inserisci quello di un amico: vedrete lo stesso itinerario e chi ha spuntato cosa.",
    group_sub_active: "Il gruppo segue l'itinerario di {country}. Le spunte si aggiornano da sole.",
    group_name_placeholder: "Il tuo nome nel gruppo",
    group_create: "Crea un codice gruppo",
    group_or: "oppure",
    group_join: "Entra",
    group_hint: "Nessuna registrazione: il gruppo vive 60 giorni e poi si cancella da solo.",
    group_code_label: "Codice gruppo",
    group_invite: "Invita",
    group_copy: "Copia",
    group_share_text: "Viaggia con me! Inserisci il codice {code} nell'Atlante del Mondo Arabo e seguiamo lo stesso itinerario ✈️",
    group_progress: "Il gruppo ha visitato {n} tappe su {total}",
    group_members_hint: "{n} nel gruppo · aggiornamento automatico ogni 20 secondi",
    group_you: "tu",
    group_leave: "Esci dal gruppo",
    group_left: "Sei uscito dal gruppo",
    group_joined: "Sei nel gruppo {code}",
    group_not_found: "Codice non trovato o scaduto",
    group_full: "Il gruppo è al completo (20 persone)",
    group_other_country: "Il tuo gruppo {code} segue l'itinerario di {country}.",
    group_open_trip: "Apri l'itinerario del gruppo",
    group_seen_by: "Visitata da {names}",
    loc_btn: "Usa la mia posizione",
    loc_hint: "Solo quando tocchi: la posizione resta sul tuo telefono",
    loc_found: "Sei in {country}: paese e numeri SOS impostati",
    loc_far: "Sei a {km} km da {country}: vuoi usarlo?",
    loc_use: "Usa",
    receipt_title: "Vuoi la ricevuta via email?",
    receipt_sub: "Ti inviamo la conferma dell'acquisto con il link per aprire l'e-book anche su un altro dispositivo. È facoltativo.",
    receipt_send: "Invia",
    receipt_skip: "No, grazie",
    receipt_sent: "Ricevuta inviata a {email}",
    receipt_privacy: "L'email viene usata solo per la ricevuta e per ripristinare l'acquisto; puoi cancellarla da Elimina i miei dati.",
    status_play: "Play Store",
    report_resolved: "Grazie: il contenuto che avevi segnalato è stato rimosso dal team",
    report_btn: "Segnala",
    report_title: "Segnala questo contenuto",
    report_sub: "Dicci perché: il team lo verifica al più presto. Con 3 segnalazioni il contenuto viene sospeso subito.",
    report_spam: "Spam o pubblicità",
    report_offensive: "Odio, insulti o molestie",
    report_inappropriate: "Contenuto esplicito o violento",
    report_copyright: "Violazione del diritto d'autore",
    report_privacy: "Dati personali o foto senza consenso",
    report_other: "Altro",
    report_note: "Dettagli (facoltativo)",
    report_send: "Invia segnalazione",
    report_sent: "Grazie, segnalazione inviata al team",
    report_error: "Invio non riuscito, riprova",
    report_hint: "La segnalazione è anonima: salviamo solo l'identificativo del dispositivo per evitare doppioni.",
    hide_author: "Nascondi i contenuti di {name}",
    hide_done: "Non vedrai più i contenuti di {name} su questo dispositivo",
    rules_title: "Regole della community",
    rules_accept: "Pubblicando accetto le {rules} e confermo di avere almeno 13 anni.",
    rules_required: "Devi accettare le regole della community per pubblicare",
    status_reported: "Segnalati",
    admin_reports_clear: "Ignora le segnalazioni",
    admin_suspended: "sospeso",
    reward_btn: "Guarda un video → +{n} punti",
    reward_title: "Video premio",
    reward_sub: "Guarda un breve annuncio fino alla fine e ricevi +{n} punti per i tuoi badge (massimo 3 volte al giorno).",
    reward_disclosure: "È facoltativo. I punti servono solo a sbloccare badge nel Passaporto, non hanno valore in denaro e non si possono convertire. Il premio viene assegnato dall'Atlante, non da Google.",
    reward_yes: "Guarda l'annuncio",
    reward_no: "No, grazie",
    reward_none: "Nessun annuncio disponibile al momento, riprova più tardi",
    arrival_title: "Sei arrivato in {country}?",
    arrival_desc: "Numeri SOS, valuta e frasi utili sono pronti nel Kit Viaggio.",
    arrival_cta: "Apri il Kit SOS",
    loc_found_dest: "Destinazione impostata: {country}",
    loc_denied: "Permesso posizione negato: scegli il paese dalle bandiere",
    loc_unavailable: "Posizione non disponibile: scegli il paese dalle bandiere",
    album_card: "Cartolina ricordo",
    album_card_sub: "Il viaggio di {name} · {n} giorni",
    album_share_text: "Il mio album di viaggio in {country} 📸 fatto con l'Atlante del Mondo Arabo",
    album_saved: "Cartolina salvata nel telefono",
    album_private: "Le foto restano solo sul tuo telefono: non vengono mai caricate.",
    delete: "Elimina",
    story_ambience: "Suoni ambiente (souq, deserto, mare)",
    save: "Salva",
    guess_board_empty: "Ancora nessun giocatore: sii il primo!",
    kit_title: "Kit Viaggio",
    kit_sub: "SOS, cambio valuta e traduttore: anche offline",
    kit_offline_mode: "Sei offline: dati salvati sul telefono",
    kit_offline_empty: "Apri questa pagina una volta con la connessione per salvare i dati offline.",
    kit_tab_sos: "SOS",
    kit_tab_currency: "Valuta",
    kit_tab_camera: "Traduttore",
    kit_embassy: "Trova la tua ambasciata su Google Maps",
    kit_embassy_query: "ambasciata",
    kit_fx_flip: "Inverti",
    kit_fx_live: "tasso aggiornato oggi",
    kit_fx_cached: "ultimo tasso salvato (offline)",
    kit_cam_cta: "Fotografa un menù o un'insegna",
    kit_cam_hint: "Legge l'arabo direttamente sul telefono; la traduzione arriva quando c'è rete",
    kit_cam_reading: "Lettura del testo…",
    kit_cam_translating: "Traduzione in corso…",
    kit_cam_original: "Testo letto",
    kit_cam_translation: "Traduzione",
    kit_cam_nothing: "Non ho trovato testo leggibile: avvicinati e riprova con più luce.",
    kit_cam_offline: "Testo letto, ma la traduzione richiede la connessione.",
    kit_cam_error: "Lettura non riuscita, riprova.",
    postcard_trip: "Cartolina",
    guess_challenge: "Sfida gli amici",
    guess_share_text: "Indovini la mia prossima destinazione? 🧭 3 tentativi, 23 bandiere:",
    guess_title: "Indovina la destinazione",
    guess_sub: "Leggi le tappe e scegli il paese giusto. Tentativi rimasti: {n}",
    guess_more_hints: "Ogni tentativo sbagliato svela un altro giorno.",
    guess_won: "Indovinato al tentativo {n}! +2 punti bonus e {p} in classifica",
    guess_lost: "Non questa volta! La destinazione era…",
    guess_wrong: "No… prova ancora",
    guess_open_trip: "Apri l'itinerario",
    guess_missing: "Link non valido: chiedi al tuo amico di condividere di nuovo la sfida.",
    ob_intro: "Cinque passi veloci e costruiamo il tuo itinerario colorato giorno per giorno.",
    ob_step: "Passo {n} di {total}",
    ob_name_title: "Come ti chiami?",
    ob_name_placeholder: "Il tuo nome…",
    ob_origin_title: "Da dove parti, {name}?",
    ob_origin_hint: "Serve per la lingua della mappa e la valuta dei prezzi di hotel e voli.",
    ob_dest_title: "Dove vuoi andare?",
    ob_days_title: "Quanti giorni resti?",
    ob_days_short: "Viaggio corto: una città e i dintorni",
    ob_days_medium: "Viaggio medio: due città o regioni",
    ob_interests_title: "Cosa ti attira di più?",
    ob_next: "Avanti",
    ob_create: "Crea il mio itinerario",
    ob_skip: "Salta",
    interest_culture: "Cultura & Storia",
    interest_adventure: "Avventura & Deserto",
    interest_shopping: "Shopping & Modernità",
    style_culture: "Custode delle Medine",
    style_adventure: "Nomade del Deserto",
    style_shopping: "Cacciatore di Souq",
    style_culture_adventure: "Esploratore Antico",
    style_culture_shopping: "Intenditore di Città",
    style_adventure_shopping: "Avventuriero Moderno",
    style_culture_adventure_shopping: "Viaggiatore Totale",
    trip_style_hint: "È il tuo stile di viaggio! Condividilo con gli amici.",
    trip_hello: "Ciao {name} 👋",
    trip_sub: "Il tuo itinerario di {n} giorni in {country}",
    trip_edit: "Modifica",
    trip_share: "Condividi il mio viaggio",
    trip_share_text: "Il mio viaggio in {country} in {n} giorni ✈️ — itinerario gratuito con mappa e numeri SOS:",
    trip_for_you: "In linea con i tuoi interessi",
    days_short: "giorni",
    tab_map: "Mappa",
    tab_warnings: "Avvisi e abbigliamento",
    tab_food: "Cibo",
    tab_book: "Prenota",
    trip_open_maps: "Apri il percorso in Google Maps",
    trip_map_unavailable: "Mappa non disponibile qui: apri il percorso in Google Maps.",
    dress_relaxed: "Abbigliamento libero",
    dress_moderate: "Abbigliamento sobrio",
    dress_strict: "Abbigliamento conservatore",
    sos_title: "Numeri di emergenza (funzionano offline)",
    sos_unified: "Numero unico",
    sos_police: "Polizia",
    sos_ambulance: "Ambulanza",
    sos_fire: "Vigili del fuoco",
    sos_tourist_police: "Polizia turistica",
    trip_upsell: "Vuoi cucinare queste ricette a casa? Sblocca il nostro Ricettario completo a soli 0,99 €",
    trip_upsell_neutral: "Vuoi cucinare queste ricette a casa? Scopri il Ricettario",
    book_hotels: "Hotel a {city}",
    book_compare: "Confronta i prezzi degli hotel",
    book_flights: "Voli",
    book_tours: "Tour ed esperienze a {city}",
    book_tickets: "Biglietti musei e attrazioni",
    book_partner: "link partner",
    book_disclosure: "Link partner: se prenoti tramite questi link l'Atlante riceve una piccola commissione, senza costi aggiuntivi per te. Si aprono nel browser.",
    app_title: "Atlante del Mondo Arabo",
    app_tagline: "Mappa interattiva della Lega Araba",
    search_placeholder: "Cerca un paese…",
    alphabet_menu: "Indice alfabetico",
    all_countries: "Tutti i paesi",
    map: "Mappa",
    quiz: "Quiz",
    compare: "Confronta",
    radio: "Radio",
    radio_title: "Radio Atlante",
    radio_tagline: "{n} canzoni dal Mondo Arabo, classiche e moderne — ascoltale di seguito o in ordine casuale.",
    radio_all: "Tutte",
    overview_kicker: "Conclusione",
    overview_cta: "Il Mondo Arabo come un solo paese",
    overview_sub: "Storia, abitanti ed economia insieme, a confronto con UE e Stati Uniti",
    radio_share: "Condividi il brano",
    radio_share_text: "Ascolta «{title}» di {artist} ({country}) su Radio Atlante 🎵",
    radio_open: "Apri Radio Atlante",
    radio_close: "Chiudi il player",
    capital: "Capitale",
    area: "Superficie",
    population: "Popolazione",
    currency: "Moneta",
    gov_type: "Governo",
    economy: "Economia",
    borders: "Confini",
    intro: "Panoramica",
    nature: "Natura",
    fauna: "Fauna simbolo",
    mountains: "Montagne",
    rivers: "Fiumi",
    history: "Storia",
    guide: "Mini guida per il visitatore",
    guide_dishes: "Piatti da provare",
    guide_cuisine: "Piatto e dolce tipici",
    guide_dish: "Piatto",
    guide_dessert: "Dolce",
    guide_street: "Street food",
    street_of_day: "Street food del giorno",
    guide_ingredients: "Ingredienti",
    recipe: "Ricetta",
    recipe_view: "Vedi la ricetta",
    recipe_servings: "Dosi per 4 persone",
    recipe_prep: "Preparazione",
    recipe_cook: "Cottura",
    recipe_steps: "Procedimento",
    recipe_video: "Guarda la video-ricetta",
    recipe_video_hint: "Si apre su YouTube",
    recipe_video_more: "Altri video su YouTube",
    cookbook: "Ricettario",
    cookbook_cta: "Ricettario del Mondo Arabo: tutti i piatti e i dolci",
    ebook: "E-book",
    ebook_title: "Quello che devi sapere del mondo arabo",
    ebook_subtitle: "{n} paesi in un solo libro: introduzione, un capitolo per paese con foto, storia, cucina e guida di viaggio, e la conclusione sul mondo arabo come un unico paese.",
    ebook_cover_note: "Stampalo o salvalo in PDF — Atlante del Mondo Arabo",
    ebook_toc: "Indice",
    ebook_chapter: "Capitolo",
    ebook_cta: "E-book: quello che devi sapere del mondo arabo",
    story_watch: "Guarda la Story",
    share_country_text: "Scopri {name} sull'Atlante del Mondo Arabo: storia, luoghi, cucina e la Story in video 👇",
    story_share: "Condividi la Story",
    story_share_text: "Ho appena visto la Story di {name} in 60 secondi ✨ Guardala anche tu:",
    paywall_app_notice: "Nell'app è disponibile l'anteprima gratuita di questo e-book.",
    badge_curious: "Curioso",
    badge_explorer: "Esploratore",
    badge_traveler: "Viaggiatore",
    badge_gourmet: "Buongustaio",
    badge_ambassador: "Ambasciatore",
    badge_sage: "Saggio del Mondo Arabo",
    badge_next: "{n} punti a {b}",
    points_have_one: "Hai 1 punto",
    paywall_bundle: "Atlante + Ricettario a {price}",
    paywall_methods_play: "Pagamento sicuro con Google Play",
    points_have: "Hai {n} punti",
    points_cost: "servono {n}",
    points_redeem: "Riscatta con i punti",
    points_how: "Guadagna punti con il quiz giornaliero, le Story, la Ruota e le recensioni: sblocchi i badge del Passaporto.",
    points_not_enough: "Punti insufficienti.",
    points_title: "I tuoi punti",
    points_earned: "+{n} punti!",
    nav_intro: "Introduzione",
    nav_itineraries: "Itinerari",
    nav_conclusion: "Conclusione",
    nav_community: "Community",
    itineraries_title: "Il tuo viaggio su misura",
    itineraries_sub: "3 o 5 giorni, mappa, avvisi e prenotazioni per 23 paesi",
    points_rules: "1 punto: quiz, Story, Ruota · 2 punti: recensione, quiz vinto · badge a 5, 15, 40, 80, 150 e 300 punti",
    paywall_wrong_book: "Questo link sblocca un altro e-book.",
    payment_open_ebook: "Apri l'e-book",
    paywall_title: "Continua a leggere",
    paywall_text: "Sblocca l'e-book completo: altri {n} contenuti, stampa e PDF inclusi. Lo sblocco resta su questo dispositivo e ricevi un link di ripristino via email.",
    paywall_buy: "Sblocca per {price}",
    paywall_methods: "Pagamento sicuro con Stripe · carta, Google Pay, Apple Pay, PayPal",
    paywall_restore: "Hai già acquistato? Ripristina con la tua email",
    paywall_restore_button: "Invia link",
    paywall_restore_sent: "Se esiste un acquisto con questa email, ti abbiamo inviato il link di ripristino.",
    paywall_email_placeholder: "la-tua@email.it",
    paywall_unlocked: "E-book sbloccato! Buona lettura.",
    paywall_invalid_link: "Link di sblocco non valido.",
    paywall_invalid_email: "Email non valida.",
    payment_checking: "Verifica del pagamento in corso…",
    payment_failed: "Pagamento non completato. Nessun addebito effettuato.",
    payment_cancel: "Pagamento annullato. Puoi riprovare quando vuoi.",
    nav_explore: "Esplora",
    nav_recipes: "Ricette",
    wheel_title: "Ruota dei Paesi",
    wheel_cta: "Dove ti porta oggi?",
    wheel_sub: "Gira la ruota: un paese a sorpresa e la sua Story in un tocco.",
    wheel_spin: "Gira la ruota",
    wheel_spinning: "La ruota gira…",
    wheel_open: "Apri la scheda",
    wheel_again: "Gira ancora",
    cookbook_end_title: "Buon appetito!",
    cookbook_end_text: "{n} ricette da {c} paesi: ora tocca a te. Fotografa il tuo piatto e condividilo nelle recensioni dell'Atlante, oppure gira la Ruota dei Paesi per scoprire la prossima cucina.",
    story_kicker: "Story del Paese",
    story_people: "abitanti",
    story_times_italy: "{x} volte l'Italia",
    story_pct_italy: "il {x}% dell'Italia",
    story_cities: "Le città più belle",
    story_food: "A tavola",
    story_languages: "Lingue",
    story_climate: "Clima",
    story_listen: "Ascolta",
    story_stop: "Stop",
    story_end_title: "Vuoi saperne di più?",
    story_end_guide: "Guida completa",
    story_end_recipes: "Ricette",
    story_tap_hint: "Tocca per avanzare · tieni premuto per mettere in pausa",
    story_unavailable: "Story non ancora disponibile per questo paese.",
    cookbook_title: "Ricettario del Mondo Arabo",
    cookbook_subtitle: "{n} ricette tradizionali da {c} paesi, dosi per 4 persone, passo dopo passo. Stampalo o salvalo in PDF.",
    cookbook_index: "Indice",
    dish_of_day: "Piatto del giorno",
    dessert_of_day: "Dolce del giorno",
    recipe_print: "Stampa la ricetta",
    recipe_hours: "h",
    recipe_min: "min",
    admin_reply_label: "Risposta dell'Atlante",
    admin_reply_placeholder: "Scrivi una risposta pubblica a questo commento…",
    admin_reply_save: "Pubblica risposta",
    admin_reply_remove: "Rimuovi risposta",
    admin_reply_saved: "Risposta pubblicata",
    admin_stats: "Statistiche",
    admin_stats_push: "Iscritti alle notifiche",
    admin_stats_players: "Giocatori questa settimana",
    admin_stats_games: "Sfide giocate questa settimana",
    admin_stats_perfect: "Punteggi pieni (5/5)",
    admin_stats_all_players: "Giocatori totali",
    admin_stats_pending: "Commenti in attesa",
    admin_stats_approved: "Commenti pubblicati",
    guide_places: "Luoghi imperdibili",
    guide_best_time: "Periodo migliore",
    guide_getting_around: "Come muoversi",
    guide_tip: "Consiglio",
    guide_itinerary: "Itinerario consigliato di 5 giorni",
    day: "Giorno",
    privacy: "Privacy",
    favorites: "Preferiti",
    add_favorite: "Aggiungi ai preferiti",
    remove_favorite: "Rimuovi dai preferiti",
    print_pdf: "Stampa / Salva PDF",
    download_guide: "Scarica la guida (PDF)",
    back: "Indietro",
    reviews: "Commenti dei visitatori",
    gallery: "Foto dei visitatori",
    song_label: "La canzone più celebre",
    song_classic: "Classica",
    listen_full: "Ascolta il brano per intero",
    preview_note: "Anteprima di 30 secondi",
    song_modern: "Moderna",
    song_play: "Riproduci",
    song_pause: "Pausa",
    music_on: "Attiva la musica automatica",
    music_off: "Disattiva la musica automatica",
    review_add_photo: "Aggiungi una foto",
    review_add_media: "Aggiungi una foto o un video",
    review_media_hint: "Una foto (JPG/PNG, max 5 MB) o un video (max 30 s, 50 MB). Eliminati automaticamente dopo 6 mesi.",
    review_video_too_long: "Video troppo lungo: massimo 30 secondi.",
    review_video_too_big: "Video troppo pesante: massimo 50 MB.",
    review_photo_too_big: "Foto troppo pesante: massimo 5 MB.",
    review_uploading: "Caricamento…",
    video_gallery: "Video dei visitatori",
    like: "Mi piace",
    unlike: "Non mi piace più",
    sorted_by_likes: "i più apprezzati prima",
    top_media: "Foto e video più amati",
    photographer_badge: "Fotografo dell'Atlante",
    media_share: "Condividi la foto",
    media_share_text: "Guarda il ricordo di viaggio di {author} da {country} sull'Atlante del Mondo Arabo 📸",
    latest_reviews: "Ultimi commenti",
    postcard: "Cartolina",
    postcard_sub: "La foto del visitatore in una cartolina digitale con bandiera e saluto: scaricala o inviala agli amici.",
    postcard_download: "Scarica la cartolina (PNG)",
    postcard_text: "Saluti da {country} 🌍 Una cartolina dall'Atlante del Mondo Arabo",
    memories_legend: "Ricordi dei visitatori",
    memories_tooltip: "{n} ricordi dei visitatori",
    live: "in diretta",
    photographer_badge_hint: "Autore della foto o del video più votato del mese",
    review_photo_hint: "Una foto del tuo viaggio (JPG/PNG, max 5 MB). Viene eliminata automaticamente dopo 6 mesi.",
    review_photo_remove: "Rimuovi foto",
    top_rated: "I più votati dai visitatori",
    review_none: "Nessun commento ancora — sii il primo a raccontare!",
    review_write: "Valuta questo paese",
    review_edit: "Modifica il tuo commento",
    review_placeholder: "Racconta la tua esperienza: cosa ti è piaciuto? Un consiglio?",
    review_send: "Invia",
    review_pending: "In attesa di approvazione",
    review_login: "Accedi con Google per lasciare un commento, una foto o un video",
    media_cta: "Lascia un commento, una foto o un video",
    review_name_placeholder: "Il tuo nome (es. Marco da Roma)",
    review_email_placeholder: "Email (facoltativa)",
    review_email_hint: "L'email non viene mai pubblicata: serve solo per avvisarti quando la tua foto raggiunge 10 Mi piace.",
    review_name_required: "Scrivi il tuo nome, per favore",
    media_pick: "Aggiungi una foto o un video (facoltativo)",
    media_cta_sub: "Valuta il paese e racconta il tuo viaggio: testo, foto o video di 30 secondi. Senza registrazione.",
    review_pick_rating: "Scegli le stelle",
    review_error: "Qualcosa è andato storto, riprova",
    logout: "Esci",
    admin_title: "Moderazione commenti",
    admin_forbidden: "Questa pagina è riservata all'amministratore",
    admin_empty: "Nessun commento qui",
    moderation: "Moderazione",
    status_pending: "In attesa",
    status_approved: "Pubblicati",
    status_rejected: "Rifiutati",
    photo_wiki: "Foto: Wikimedia",
    demographics: "Popolazione e città",
    age_distribution: "Distribuzione per età",
    largest_city: "Città più grande",
    inhabitants: "abitanti",
    age_0_14: "0–14 anni",
    age_15_29: "15–29 anni",
    age_30_59: "30–59 anni",
    age_60plus: "60+ anni",
    source_wb: "Fonte: Banca Mondiale",
    independence: "Indipendenza",
    industrial_city: "Città industriale",
    religious_city: "Città religiosa",
    historical_note: "Nota storica",
    prev: "Precedente",
    next: "Successivo",
    close: "Chiudi",
    disputed: "Territorio conteso",
    no_borders: "Nessun confine terrestre",
    km2: "km²",
    people: "persone",
    million: "M",
    quiz_intro: "Indovina il paese dalla sua bandiera",
    quiz_score: "Punteggio",
    quiz_next: "Successivo",
    quiz_correct: "Corretto!",
    quiz_wrong: "Risposta corretta:",
    compare_pick: "Scegli due paesi da confrontare",
    compare_country_a: "Paese A",
    compare_country_b: "Paese B",
    reset: "Reset",
    language: "Lingua",
    footer: "Un atlante didattico semplificato. Dati indicativi.",
    no_results: "Nessun risultato",
    home: "Home",
    open_menu: "Menu",
    kbd_hint: "← → per navigare, / per cercare, Esc per chiudere",
    random: "Paese casuale",
    recent: "Visti di recente",
    share: "Condividi",
    share_app: "Condividi l'app",
    share_app_text: "Scopri l'Atlante Interattivo del Mondo Arabo: 22 paesi, mappe, bandiere, storia e quiz 🌍",
    copied: "Link copiato",
    badge_champion: "Campione della settimana",
    champion_req: "Vinci la classifica settimanale della Sfida (lunedì→domenica)",
    champion_won: "Hai vinto la classifica con {total} punti. Ti arriva una notifica ogni lunedì che vinci!",
    lb_last_champion: "Campione dell'ultima settimana: {nick} con {total} punti",
    vs_create: "Sfida un amico",
    vs_rematch: "Rilancia la sfida",
    vs_ready: "Link pronto: chi lo apre gioca le tue stesse 5 domande",
    vs_share_text: "Ho fatto {score} nella Sfida Atlante #{n} — riesci a battermi?",
    vs_anon: "Un amico",
    vs_banner: "Ti ha sfidato {name}",
    vs_yours: "La tua sfida di oggi",
    vs_expired: "Sfida scaduta: gioca quella di oggi!",
    vs_missing: "Sfida non trovata: gioca quella di oggi!",
    vs_you: "Tu",
    vs_win: "Hai vinto! Hai battuto {name}",
    vs_draw: "Pareggio con {name}",
    vs_lose: "Ha vinto {name}… rivincita domani!",
    vs_stats: "{n} amici hanno accettato la sfida, {k} ti hanno battuto",
    push_cta: "Avvisami ogni giorno alle 9",
    push_on: "Promemoria attivo",
    push_denied: "Notifiche bloccate nel browser",
    push_hint: "Ricevi il paese del giorno e la nuova sfida alle 9:00",
    push_off_hint: "Tocca per disattivare il promemoria",
    nick_title: "Entra in classifica con un nickname",
    nick_placeholder: "Il tuo nickname",
    nick_save: "Salva",
    nick_hint: "2-20 caratteri, lettere e numeri. Un punteggio al giorno per dispositivo.",
    nick_invalid: "Nickname non valido",
    nick_saved: "Punteggio salvato come {nick}",
    lb_title: "Classifica della settimana",
    lb_sub: "Da lunedì a domenica: somma dei punti delle sfide giornaliere. Si azzera ogni lunedì.",
    lb_players: "{n} giocatori",
    country_of_day: "Paese del giorno",
    daily_challenge: "Sfida del giorno",
    daily_cta: "Gioca ora",
    daily_sub: "5 domande, uguali per tutti, una volta al giorno",
    daily_done_hint: "Torna domani per la prossima sfida",
    daily_streak: "Serie: {n} giorni",
    daily_streak_one: "Serie: 1 giorno",
    daily_q_capital: "Di quale paese è la capitale?",
    daily_q_fauna: "Quale paese ha questo animale simbolo?",
    daily_q_currency: "Quale paese usa questa valuta?",
    daily_q_region: "Quale paese appartiene a questa macro-area?",
    intro_read_more: "Leggi l'introduzione completa",
    daily_finish: "Vedi il risultato",
    daily_share: "Sfida Atlante #{n}: {score}",
    daily_come_back: "Nuova sfida ogni giorno a mezzanotte. Condividi il tuo risultato e sfida gli amici!",
    quiz_practice: "Allenamento",
    passport: "Passaporto dell'Atlante",
    passport_kicker: "Il tuo viaggio",
    passport_intro: "Ogni paese che apri riceve un timbro. Collezionali tutti e sblocca i badge.",
    passport_next: "Ancora {n} per il badge {badge}",
    passport_complete: "Hai visitato tutto il mondo arabo!",
    passport_current: "Badge attuale:",
    passport_start: "Apri un paese per il primo timbro",
    passport_explore: "Esplora la mappa",
    passport_share: "Il mio Passaporto dell'Atlante: {n}/{total} paesi, badge {badge} 🛂",
    badges: "Badge",
    badge_req: "{n} paesi visitati",
    badge_explorer: "Esploratore",
    badge_traveller: "Viaggiatore",
    badge_connoisseur: "Conoscitore",
    badge_master: "Maestro dell'Atlante",
    badge_none: "nessuno",
    badge_unlocked: "Nuovo badge:",
    stamp_new: "Nuovo timbro: {country} 🛂",
    install_title: "Installa l'Atlante del Mondo Arabo",
    install_text: "Aggiungilo alla schermata Home: si apre a schermo intero e funziona offline.",
    install_action: "Installa app",
    install_ios_hint: "In Safari tocca il pulsante Condividi, poi:",
    install_ios_action: "Aggiungi alla schermata Home",
  },
  fr: {
    kit_tab_phrases: "Phrases",
    kit_tab_packing: "Valise",
    phrases_search: "Chercher une phrase…",
    phrases_play: "Écouter la prononciation",
    phrases_voice_hint: "Pour l'audio hors ligne, installez une voix arabe dans les réglages du téléphone (Synthèse vocale).",
    pack_docs: "Documents et argent",
    pack_clothes: "Vêtements",
    pack_health: "Santé",
    pack_tech: "Technologie",
    pack_extra: "Extras utiles",
    packing_reset: "Réinitialiser",
    diary_title: "Carnet de voyage",
    diary_visited: "Marquer comme visité",
    diary_complete_title: "Voyage en {country} terminé !",
    diary_complete_desc: "Vous avez gagné le tampon Carnet dans le Passeport et +5 points",
    badge_diary: "Carnet de voyage",
    diary_badge_req: "Cochez toutes les étapes d'un itinéraire pour recevoir le tampon",
    diary_badge_done: "{n} voyages terminés avec toutes les étapes",
    diary_badge_done_one: "1 voyage terminé avec toutes les étapes",
    guess_by: "Défi de {name}",
    guess_counter: "Créez votre défi",
    guess_board_title: "Classement des défis",
    guess_board_sub: "3 points au premier essai, 2 au deuxième, 1 au troisième · {n} joueurs",
    guess_name_placeholder: "Votre nom au classement",
    guess_name_saved: "Nom enregistré",
    guess_you: "vous",
    album_title: "Album de voyage",
    album_add: "Ajouter une photo à cette étape",
    album_added: "Photo ajoutée à l'album",
    group_title: "Amis en voyage",
    group_btn: "Amis",
    group_sub: "Créez un code pour {country} ou saisissez celui d'un ami : même itinéraire, et vous voyez qui a coché quoi.",
    group_sub_active: "Le groupe suit l'itinéraire de {country}. Les coches se mettent à jour automatiquement.",
    group_name_placeholder: "Votre prénom dans le groupe",
    group_create: "Créer un code de groupe",
    group_or: "ou",
    group_join: "Rejoindre",
    group_hint: "Sans inscription : le groupe vit 60 jours puis s'efface tout seul.",
    group_code_label: "Code du groupe",
    group_invite: "Inviter",
    group_copy: "Copier",
    group_share_text: "Voyage avec moi ! Saisis le code {code} dans l'Atlas du Monde Arabe et suivons le même itinéraire ✈️",
    group_progress: "Le groupe a visité {n} étapes sur {total}",
    group_members_hint: "{n} dans le groupe · mise à jour toutes les 20 secondes",
    group_you: "vous",
    group_leave: "Quitter le groupe",
    group_left: "Vous avez quitté le groupe",
    group_joined: "Vous êtes dans le groupe {code}",
    group_not_found: "Code introuvable ou expiré",
    group_full: "Le groupe est complet (20 personnes)",
    group_other_country: "Votre groupe {code} suit l'itinéraire de {country}.",
    group_open_trip: "Ouvrir l'itinéraire du groupe",
    group_seen_by: "Visitée par {names}",
    loc_btn: "Utiliser ma position",
    loc_hint: "Seulement quand vous appuyez : la position reste sur votre téléphone",
    loc_found: "Vous êtes en {country} : pays et numéros SOS réglés",
    loc_far: "Vous êtes à {km} km de {country} : l'utiliser ?",
    loc_use: "Utiliser",
    receipt_title: "Voulez-vous le reçu par e-mail ?",
    receipt_sub: "Nous vous envoyons la confirmation d'achat avec le lien pour ouvrir l'e-book sur un autre appareil. Facultatif.",
    receipt_send: "Envoyer",
    receipt_skip: "Non merci",
    receipt_sent: "Reçu envoyé à {email}",
    receipt_privacy: "L'e-mail sert uniquement au reçu et à restaurer l'achat ; vous pouvez le supprimer depuis Supprimer mes données.",
    status_play: "Play Store",
    report_resolved: "Merci : le contenu que vous aviez signalé a été retiré par l'équipe",
    report_btn: "Signaler",
    report_title: "Signaler ce contenu",
    report_sub: "Dites-nous pourquoi : l'équipe vérifie au plus vite. Après 3 signalements, le contenu est suspendu immédiatement.",
    report_spam: "Spam ou publicité",
    report_offensive: "Haine, insultes ou harcèlement",
    report_inappropriate: "Contenu explicite ou violent",
    report_copyright: "Violation du droit d'auteur",
    report_privacy: "Données personnelles ou photo sans consentement",
    report_other: "Autre",
    report_note: "Détails (facultatif)",
    report_send: "Envoyer le signalement",
    report_sent: "Merci, signalement envoyé à l'équipe",
    report_error: "Envoi impossible, réessayez",
    report_hint: "Le signalement est anonyme : nous ne gardons que l'identifiant de l'appareil pour éviter les doublons.",
    hide_author: "Masquer les contenus de {name}",
    hide_done: "Vous ne verrez plus les contenus de {name} sur cet appareil",
    rules_title: "Règles de la communauté",
    rules_accept: "En publiant, j'accepte les {rules} et je confirme avoir au moins 13 ans.",
    rules_required: "Vous devez accepter les règles de la communauté pour publier",
    status_reported: "Signalés",
    admin_reports_clear: "Ignorer les signalements",
    admin_suspended: "suspendu",
    reward_btn: "Regarder une vidéo → +{n} points",
    reward_title: "Vidéo récompense",
    reward_sub: "Regardez une courte publicité jusqu'au bout et recevez +{n} points pour vos badges (3 fois par jour maximum).",
    reward_disclosure: "C'est facultatif. Les points ne servent qu'à débloquer des badges dans le Passeport, n'ont aucune valeur monétaire et ne sont pas convertibles. La récompense est attribuée par l'Atlas, pas par Google.",
    reward_yes: "Regarder la publicité",
    reward_no: "Non merci",
    reward_none: "Aucune publicité disponible pour le moment, réessayez plus tard",
    arrival_title: "Vous êtes arrivé en {country} ?",
    arrival_desc: "Numéros SOS, devise et phrases utiles vous attendent dans le Kit Voyage.",
    arrival_cta: "Ouvrir le Kit SOS",
    loc_found_dest: "Destination définie : {country}",
    loc_denied: "Permission de localisation refusée : choisissez le pays parmi les drapeaux",
    loc_unavailable: "Position indisponible : choisissez le pays parmi les drapeaux",
    album_card: "Carte souvenir",
    album_card_sub: "Le voyage de {name} · {n} jours",
    album_share_text: "Mon album de voyage : {country} 📸 fait avec l'Atlas du monde arabe",
    album_saved: "Carte enregistrée sur le téléphone",
    album_private: "Les photos restent uniquement sur votre téléphone : jamais téléversées.",
    delete: "Supprimer",
    story_ambience: "Sons d'ambiance (souk, désert, mer)",
    save: "Enregistrer",
    guess_board_empty: "Aucun joueur pour l'instant : soyez le premier !",
    kit_title: "Kit Voyage",
    kit_sub: "SOS, change et traducteur — même hors ligne",
    kit_offline_mode: "Vous êtes hors ligne : données enregistrées sur le téléphone",
    kit_offline_empty: "Ouvrez cette page une fois en ligne pour enregistrer les données hors ligne.",
    kit_tab_sos: "SOS",
    kit_tab_currency: "Devise",
    kit_tab_camera: "Traducteur",
    kit_embassy: "Trouver votre ambassade sur Google Maps",
    kit_embassy_query: "ambassade",
    kit_fx_flip: "Inverser",
    kit_fx_live: "taux mis à jour aujourd'hui",
    kit_fx_cached: "dernier taux enregistré (hors ligne)",
    kit_cam_cta: "Photographiez un menu ou un panneau",
    kit_cam_hint: "Lit l'arabe directement sur le téléphone ; la traduction arrive avec la connexion",
    kit_cam_reading: "Lecture du texte…",
    kit_cam_translating: "Traduction…",
    kit_cam_original: "Texte lu",
    kit_cam_translation: "Traduction",
    kit_cam_nothing: "Aucun texte lisible : rapprochez-vous et réessayez avec plus de lumière.",
    kit_cam_offline: "Texte lu, mais la traduction nécessite une connexion.",
    kit_cam_error: "Lecture impossible, réessayez.",
    postcard_trip: "Carte postale",
    guess_challenge: "Défiez vos amis",
    guess_share_text: "Devinez ma prochaine destination ? 🧭 3 essais, 23 drapeaux :",
    guess_title: "Devinez la destination",
    guess_sub: "Lisez les étapes et choisissez le bon pays. Essais restants : {n}",
    guess_more_hints: "Chaque erreur dévoile un jour de plus.",
    guess_won: "Trouvé à l'essai {n} ! +2 points bonus et {p} au classement",
    guess_lost: "Pas cette fois ! La destination était…",
    guess_wrong: "Non… réessayez",
    guess_open_trip: "Ouvrir l'itinéraire",
    guess_missing: "Lien invalide : demandez à votre ami de repartager le défi.",
    ob_intro: "Cinq étapes rapides et nous construisons votre itinéraire coloré jour par jour.",
    ob_step: "Étape {n} sur {total}",
    ob_name_title: "Comment vous appelez-vous ?",
    ob_name_placeholder: "Votre prénom…",
    ob_origin_title: "D'où partez-vous, {name} ?",
    ob_origin_hint: "Sert à la langue de la carte et à la devise des prix d'hôtels et de vols.",
    ob_dest_title: "Où voulez-vous aller ?",
    ob_days_title: "Combien de jours ?",
    ob_days_short: "Court séjour : une ville et ses environs",
    ob_days_medium: "Séjour moyen : deux villes ou régions",
    ob_interests_title: "Qu'est-ce qui vous attire le plus ?",
    ob_next: "Suivant",
    ob_create: "Créer mon itinéraire",
    ob_skip: "Passer",
    interest_culture: "Culture & Histoire",
    interest_adventure: "Aventure & Désert",
    interest_shopping: "Shopping & Modernité",
    style_culture: "Gardien des Médinas",
    style_adventure: "Nomade du Désert",
    style_shopping: "Chasseur de Souks",
    style_culture_adventure: "Explorateur Antique",
    style_culture_shopping: "Connaisseur des Villes",
    style_adventure_shopping: "Aventurier Moderne",
    style_culture_adventure_shopping: "Voyageur Total",
    trip_style_hint: "C'est votre style de voyage ! Partagez-le avec vos amis.",
    trip_hello: "Bonjour {name} 👋",
    trip_sub: "Votre itinéraire de {n} jours : {country}",
    trip_edit: "Modifier",
    trip_share: "Partager mon voyage",
    trip_share_text: "Mon voyage de {n} jours : {country} ✈️ — itinéraire gratuit avec carte et numéros SOS :",
    trip_for_you: "Selon vos centres d'intérêt",
    days_short: "jours",
    tab_map: "Carte",
    tab_warnings: "Alertes et tenue",
    tab_food: "Cuisine",
    tab_book: "Réserver",
    trip_open_maps: "Ouvrir l'itinéraire dans Google Maps",
    trip_map_unavailable: "Carte indisponible ici : ouvrez l'itinéraire dans Google Maps.",
    dress_relaxed: "Tenue libre",
    dress_moderate: "Tenue sobre",
    dress_strict: "Tenue conservatrice",
    sos_title: "Numéros d'urgence (hors ligne)",
    sos_unified: "Numéro unique",
    sos_police: "Police",
    sos_ambulance: "Ambulance",
    sos_fire: "Pompiers",
    sos_tourist_police: "Police touristique",
    trip_upsell: "Envie de cuisiner ces recettes chez vous ? Débloquez notre Livre de recettes complet pour seulement 0,99 €",
    trip_upsell_neutral: "Envie de cuisiner ces recettes chez vous ? Découvrez le Livre de recettes",
    book_hotels: "Hôtels à {city}",
    book_compare: "Comparer les prix des hôtels",
    book_flights: "Vols",
    book_tours: "Visites et expériences à {city}",
    book_tickets: "Billets musées et attractions",
    book_partner: "lien partenaire",
    book_disclosure: "Liens partenaires : si vous réservez via ces liens, l'Atlas touche une petite commission sans surcoût pour vous. Ils s'ouvrent dans le navigateur.",
    app_title: "Atlas du Monde Arabe",
    app_tagline: "Carte interactive de la Ligue arabe",
    search_placeholder: "Rechercher un pays…",
    alphabet_menu: "Index alphabétique",
    all_countries: "Tous les pays",
    map: "Carte",
    quiz: "Quiz",
    compare: "Comparer",
    radio: "Radio",
    radio_title: "Radio Atlas",
    radio_tagline: "{n} chansons du monde arabe, classiques et modernes — à la suite ou en aléatoire.",
    radio_all: "Toutes",
    overview_kicker: "Conclusion",
    overview_cta: "Le Monde arabe comme un seul pays",
    overview_sub: "Histoire, habitants et économie réunis, comparés à l'UE et aux États-Unis",
    radio_share: "Partager la chanson",
    radio_share_text: "Écoutez « {title} » de {artist} ({country}) sur Radio Atlas 🎵",
    radio_open: "Ouvrir Radio Atlas",
    radio_close: "Fermer le lecteur",
    capital: "Capitale",
    area: "Superficie",
    population: "Population",
    currency: "Monnaie",
    gov_type: "Gouvernement",
    economy: "Économie",
    borders: "Frontières",
    intro: "Aperçu",
    nature: "Nature",
    fauna: "Faune emblématique",
    mountains: "Montagnes",
    rivers: "Fleuves",
    history: "Histoire",
    guide: "Mini-guide du visiteur",
    guide_dishes: "Plats à goûter",
    guide_cuisine: "Plat et dessert typiques",
    guide_dish: "Plat",
    guide_dessert: "Dessert",
    guide_street: "Street food",
    street_of_day: "Street food du jour",
    guide_ingredients: "Ingrédients",
    recipe: "Recette",
    recipe_view: "Voir la recette",
    recipe_servings: "Pour 4 personnes",
    recipe_prep: "Préparation",
    recipe_cook: "Cuisson",
    recipe_steps: "Préparation pas à pas",
    recipe_video: "Voir la recette en vidéo",
    recipe_video_hint: "S'ouvre sur YouTube",
    recipe_video_more: "Plus de vidéos sur YouTube",
    cookbook: "Livre de recettes",
    cookbook_cta: "Livre de recettes du monde arabe : tous les plats et desserts",
    ebook: "E-book",
    ebook_title: "Ce qu'il faut savoir sur le monde arabe",
    ebook_subtitle: "{n} pays dans un seul livre : introduction, un chapitre par pays avec photos, histoire, cuisine et guide de voyage, et une conclusion sur le monde arabe comme un seul pays.",
    ebook_cover_note: "Imprimez-le ou enregistrez-le en PDF — Atlas du monde arabe",
    ebook_toc: "Sommaire",
    ebook_chapter: "Chapitre",
    ebook_cta: "E-book : ce qu'il faut savoir sur le monde arabe",
    story_watch: "Voir la Story",
    share_country_text: "Découvrez {name} sur l'Atlas du monde arabe : histoire, lieux, cuisine et la Story vidéo 👇",
    story_share: "Partager la Story",
    story_share_text: "Je viens de voir la Story de {name} en 60 secondes ✨ Regardez-la aussi :",
    paywall_app_notice: "L'aperçu gratuit de cet e-book est disponible dans l'application.",
    badge_curious: "Curieux",
    badge_explorer: "Explorateur",
    badge_traveler: "Voyageur",
    badge_gourmet: "Gourmet",
    badge_ambassador: "Ambassadeur",
    badge_sage: "Sage du monde arabe",
    badge_next: "{n} points avant {b}",
    points_have_one: "Vous avez 1 point",
    paywall_bundle: "Atlas + Recettes pour {price}",
    paywall_methods_play: "Paiement sécurisé avec Google Play",
    points_have: "Vous avez {n} points",
    points_cost: "{n} requis",
    points_redeem: "Échanger mes points",
    points_how: "Gagnez des points avec le quiz quotidien, les Stories, la Roue et les avis : débloquez les badges du Passeport.",
    points_not_enough: "Points insuffisants.",
    points_title: "Vos points",
    points_earned: "+{n} points !",
    nav_intro: "Introduction",
    nav_itineraries: "Itinéraires",
    nav_conclusion: "Conclusion",
    nav_community: "Communauté",
    itineraries_title: "Votre voyage sur mesure",
    itineraries_sub: "3 ou 5 jours, carte, alertes et réservations pour 23 pays",
    points_rules: "1 point : quiz, Story, Roue · 2 points : avis, quiz gagné · badges à 5, 15, 40, 80, 150 et 300 points",
    paywall_wrong_book: "Ce lien débloque un autre e-book.",
    payment_open_ebook: "Ouvrir l'e-book",
    paywall_title: "Continuer la lecture",
    paywall_text: "Débloquez l'e-book complet : {n} contenus de plus, impression et PDF inclus. Le déblocage reste sur cet appareil et vous recevez un lien de restauration par e-mail.",
    paywall_buy: "Débloquer pour {price}",
    paywall_methods: "Paiement sécurisé avec Stripe · carte, Google Pay, Apple Pay, PayPal",
    paywall_restore: "Déjà acheté ? Restaurer avec votre e-mail",
    paywall_restore_button: "Envoyer le lien",
    paywall_restore_sent: "Si un achat existe pour cet e-mail, nous vous avons envoyé le lien de restauration.",
    paywall_email_placeholder: "votre@email.fr",
    paywall_unlocked: "E-book débloqué ! Bonne lecture.",
    paywall_invalid_link: "Lien de déblocage invalide.",
    paywall_invalid_email: "E-mail invalide.",
    payment_checking: "Vérification du paiement…",
    payment_failed: "Paiement non finalisé. Aucun débit effectué.",
    payment_cancel: "Paiement annulé. Vous pouvez réessayer quand vous voulez.",
    nav_explore: "Explorer",
    nav_recipes: "Recettes",
    wheel_title: "Roue des pays",
    wheel_cta: "Où vous emmène-t-elle aujourd'hui ?",
    wheel_sub: "Tournez la roue : un pays surprise et sa Story en un geste.",
    wheel_spin: "Tourner la roue",
    wheel_spinning: "La roue tourne…",
    wheel_open: "Ouvrir la fiche",
    wheel_again: "Tourner encore",
    cookbook_end_title: "Bon appétit !",
    cookbook_end_text: "{n} recettes de {c} pays : à vous de jouer. Photographiez votre plat et partagez-le dans les avis de l'Atlas, ou tournez la Roue des pays pour découvrir la prochaine cuisine.",
    story_kicker: "Story du pays",
    story_people: "habitants",
    story_times_italy: "{x} fois l'Italie",
    story_pct_italy: "{x} % de l'Italie",
    story_cities: "Les plus beaux lieux",
    story_food: "À table",
    story_languages: "Langues",
    story_climate: "Climat",
    story_listen: "Écouter",
    story_stop: "Stop",
    story_end_title: "Envie d'en savoir plus ?",
    story_end_guide: "Guide complet",
    story_end_recipes: "Recettes",
    story_tap_hint: "Touchez pour avancer · maintenez pour mettre en pause",
    story_unavailable: "Story pas encore disponible pour ce pays.",
    cookbook_title: "Livre de recettes du monde arabe",
    cookbook_subtitle: "{n} recettes traditionnelles de {c} pays, pour 4 personnes, pas à pas. Imprimez-le ou enregistrez-le en PDF.",
    cookbook_index: "Sommaire",
    dish_of_day: "Plat du jour",
    dessert_of_day: "Dessert du jour",
    recipe_print: "Imprimer la recette",
    recipe_hours: "h",
    recipe_min: "min",
    admin_reply_label: "Réponse de l'Atlas",
    admin_reply_placeholder: "Écrivez une réponse publique à ce commentaire…",
    admin_reply_save: "Publier la réponse",
    admin_reply_remove: "Supprimer la réponse",
    admin_reply_saved: "Réponse publiée",
    admin_stats: "Statistiques",
    admin_stats_push: "Abonnés aux notifications",
    admin_stats_players: "Joueurs cette semaine",
    admin_stats_games: "Défis joués cette semaine",
    admin_stats_perfect: "Scores parfaits (5/5)",
    admin_stats_all_players: "Joueurs au total",
    admin_stats_pending: "Commentaires en attente",
    admin_stats_approved: "Commentaires publiés",
    guide_places: "Lieux incontournables",
    guide_best_time: "Meilleure période",
    guide_getting_around: "Se déplacer",
    guide_tip: "Conseil",
    guide_itinerary: "Itinéraire conseillé de 5 jours",
    day: "Jour",
    privacy: "Confidentialité",
    favorites: "Favoris",
    add_favorite: "Ajouter aux favoris",
    remove_favorite: "Retirer des favoris",
    print_pdf: "Imprimer / Enregistrer en PDF",
    download_guide: "Télécharger le guide (PDF)",
    back: "Retour",
    reviews: "Avis des visiteurs",
    gallery: "Photos des visiteurs",
    song_label: "La chanson emblématique",
    song_classic: "Classique",
    listen_full: "Écouter la chanson en entier",
    preview_note: "Extrait de 30 secondes",
    song_modern: "Moderne",
    song_play: "Lecture",
    song_pause: "Pause",
    music_on: "Activer la musique automatique",
    music_off: "Désactiver la musique automatique",
    review_add_photo: "Ajouter une photo",
    review_add_media: "Ajouter une photo ou une vidéo",
    review_media_hint: "Une photo (JPG/PNG, 5 Mo max) ou une vidéo (30 s, 50 Mo max). Supprimées automatiquement après 6 mois.",
    review_video_too_long: "Vidéo trop longue : 30 secondes max.",
    review_video_too_big: "Vidéo trop lourde : 50 Mo max.",
    review_photo_too_big: "Photo trop lourde : 5 Mo max.",
    review_uploading: "Envoi…",
    video_gallery: "Vidéos des visiteurs",
    like: "J'aime",
    unlike: "Je n'aime plus",
    sorted_by_likes: "les plus aimés d'abord",
    top_media: "Photos et vidéos les plus aimées",
    photographer_badge: "Photographe de l'Atlas",
    media_share: "Partager la photo",
    media_share_text: "Découvrez le souvenir de voyage de {author} depuis {country} sur l'Atlas du Monde Arabe 📸",
    latest_reviews: "Derniers commentaires",
    postcard: "Carte postale",
    postcard_sub: "La photo du visiteur en carte postale numérique avec drapeau et salutation : téléchargez-la ou envoyez-la à vos amis.",
    postcard_download: "Télécharger la carte (PNG)",
    postcard_text: "Salutations de {country} 🌍 Une carte postale de l'Atlas du Monde Arabe",
    memories_legend: "Souvenirs des visiteurs",
    memories_tooltip: "{n} souvenirs des visiteurs",
    live: "en direct",
    photographer_badge_hint: "Auteur de la photo ou vidéo la plus aimée ce mois-ci",
    review_photo_hint: "Une photo de votre voyage (JPG/PNG, 5 Mo max). Supprimée automatiquement après 6 mois.",
    review_photo_remove: "Retirer la photo",
    top_rated: "Les mieux notés par les visiteurs",
    review_none: "Aucun avis pour l'instant — soyez le premier !",
    review_write: "Notez ce pays",
    review_edit: "Modifier votre avis",
    review_placeholder: "Partagez votre expérience : qu'avez-vous aimé ? Un conseil ?",
    review_send: "Envoyer",
    review_pending: "En attente d'approbation",
    review_login: "Connectez-vous avec Google pour laisser un avis, une photo ou une vidéo",
    media_cta: "Laissez un commentaire, une photo ou une vidéo",
    review_name_placeholder: "Votre nom (ex. Julie de Lyon)",
    review_email_placeholder: "E-mail (facultatif)",
    review_email_hint: "Votre e-mail n'est jamais publié : il sert uniquement à vous prévenir quand votre photo atteint 10 J'aime.",
    review_name_required: "Veuillez indiquer votre nom",
    media_pick: "Ajouter une photo ou une vidéo (facultatif)",
    media_cta_sub: "Notez le pays et racontez votre voyage : texte, photo ou vidéo de 30 secondes. Sans inscription.",
    review_pick_rating: "Choisissez le nombre d'étoiles",
    review_error: "Une erreur est survenue, réessayez",
    logout: "Se déconnecter",
    admin_title: "Modération des avis",
    admin_forbidden: "Cette page est réservée à l'administrateur",
    admin_empty: "Rien ici",
    moderation: "Modération",
    status_pending: "En attente",
    status_approved: "Publiés",
    status_rejected: "Refusés",
    photo_wiki: "Photo : Wikimedia",
    demographics: "Population et villes",
    age_distribution: "Répartition par âge",
    largest_city: "Plus grande ville",
    inhabitants: "habitants",
    age_0_14: "0–14 ans",
    age_15_29: "15–29 ans",
    age_30_59: "30–59 ans",
    age_60plus: "60+ ans",
    source_wb: "Source : Banque mondiale",
    independence: "Indépendance",
    industrial_city: "Ville industrielle",
    religious_city: "Ville religieuse",
    historical_note: "Note historique",
    prev: "Précédent",
    next: "Suivant",
    close: "Fermer",
    disputed: "Territoire contesté",
    no_borders: "Aucune frontière terrestre",
    km2: "km²",
    people: "personnes",
    million: "M",
    quiz_intro: "Devinez le pays d'après son drapeau",
    quiz_score: "Score",
    quiz_next: "Suivant",
    quiz_correct: "Correct !",
    quiz_wrong: "Bonne réponse :",
    compare_pick: "Choisissez deux pays à comparer",
    compare_country_a: "Pays A",
    compare_country_b: "Pays B",
    reset: "Reset",
    language: "Langue",
    footer: "Un atlas éducatif simplifié. Données indicatives.",
    no_results: "Aucun résultat",
    home: "Accueil",
    open_menu: "Menu",
    kbd_hint: "← → pour naviguer, / pour rechercher, Échap pour fermer",
    random: "Pays aléatoire",
    recent: "Vus récemment",
    share: "Partager",
    share_app: "Partager l'app",
    share_app_text: "Découvrez l'Atlas Interactif du Monde Arabe : 22 pays, cartes, drapeaux, histoire et quiz 🌍",
    copied: "Lien copié",
    badge_champion: "Champion de la semaine",
    champion_req: "Remportez le classement hebdomadaire du Défi (lundi→dimanche)",
    champion_won: "Vous avez remporté le classement avec {total} points. Une notification vous arrive chaque lundi gagné !",
    lb_last_champion: "Champion de la semaine dernière : {nick} avec {total} points",
    vs_create: "Défier un ami",
    vs_rematch: "Relancer le défi",
    vs_ready: "Lien prêt : celui qui l'ouvre joue vos 5 mêmes questions",
    vs_share_text: "J'ai fait {score} au Défi Atlas #{n} — peux-tu me battre ?",
    vs_anon: "Un ami",
    vs_banner: "{name} vous a défié",
    vs_yours: "Votre défi du jour",
    vs_expired: "Défi expiré : jouez celui d'aujourd'hui !",
    vs_missing: "Défi introuvable : jouez celui d'aujourd'hui !",
    vs_you: "Vous",
    vs_win: "Gagné ! Vous avez battu {name}",
    vs_draw: "Égalité avec {name}",
    vs_lose: "{name} a gagné… revanche demain !",
    vs_stats: "{n} amis ont accepté votre défi, {k} vous ont battu",
    push_cta: "Rappel chaque jour à 9 h",
    push_on: "Rappel activé",
    push_denied: "Notifications bloquées dans le navigateur",
    push_hint: "Recevez le pays du jour et le nouveau défi à 9 h",
    push_off_hint: "Touchez pour désactiver le rappel",
    nick_title: "Entrez au classement avec un pseudo",
    nick_placeholder: "Votre pseudo",
    nick_save: "Enregistrer",
    nick_hint: "2 à 20 caractères, lettres et chiffres. Un score par jour et par appareil.",
    nick_invalid: "Pseudo invalide",
    nick_saved: "Score enregistré sous {nick}",
    lb_title: "Classement de la semaine",
    lb_sub: "Du lundi au dimanche : somme des points des défis quotidiens. Remis à zéro chaque lundi.",
    lb_players: "{n} joueurs",
    country_of_day: "Pays du jour",
    daily_challenge: "Défi du jour",
    daily_cta: "Jouer",
    daily_sub: "5 questions, les mêmes pour tous, une fois par jour",
    daily_done_hint: "Revenez demain pour le prochain défi",
    daily_streak: "Série : {n} jours",
    daily_streak_one: "Série : 1 jour",
    daily_q_capital: "De quel pays est-ce la capitale ?",
    daily_q_fauna: "Quel pays a cet animal emblématique ?",
    daily_q_currency: "Quel pays utilise cette monnaie ?",
    daily_q_region: "Quel pays appartient à cette grande région ?",
    intro_read_more: "Lire l'introduction complète",
    daily_finish: "Voir le résultat",
    daily_share: "Défi Atlas #{n} : {score}",
    daily_come_back: "Un nouveau défi chaque jour à minuit. Partagez votre résultat et défiez vos amis !",
    quiz_practice: "Entraînement",
    passport: "Passeport de l'Atlas",
    passport_kicker: "Votre voyage",
    passport_intro: "Chaque pays ouvert reçoit un tampon. Collectionnez-les tous et débloquez des badges.",
    passport_next: "Encore {n} pour le badge {badge}",
    passport_complete: "Vous avez visité tout le monde arabe !",
    passport_current: "Badge actuel :",
    passport_start: "Ouvrez un pays pour votre premier tampon",
    passport_explore: "Explorer la carte",
    passport_share: "Mon Passeport de l'Atlas : {n}/{total} pays, badge {badge} 🛂",
    badges: "Badges",
    badge_req: "{n} pays visités",
    badge_explorer: "Explorateur",
    badge_traveller: "Voyageur",
    badge_connoisseur: "Connaisseur",
    badge_master: "Maître de l'Atlas",
    badge_none: "aucun",
    badge_unlocked: "Nouveau badge :",
    stamp_new: "Nouveau tampon : {country} 🛂",
    install_title: "Installer l'Atlas du Monde Arabe",
    install_text: "Ajoutez-le à votre écran d'accueil : plein écran et fonctionne hors ligne.",
    install_action: "Installer l'app",
    install_ios_hint: "Dans Safari, touchez Partager, puis :",
    install_ios_action: "Sur l'écran d'accueil",
  },
};

export function fmtNumber(n, lang) {
  if (n == null) return "—";
  // Arabic uses Western digits (0-9) by request: "ar-u-nu-latn" keeps Arabic grouping with Latin numerals.
  const locale = { ar: "ar-EG-u-nu-latn", en: "en-US", it: "it-IT", fr: "fr-FR" }[lang] || "en-US";
  try {
    return new Intl.NumberFormat(locale).format(n);
  } catch {
    return String(n);
  }
}

// Return the value of a LocalizedString field for the active language,
// falling back to English then to the first available string.
export function pick(field, lang) {
  if (field == null) return "";
  if (typeof field === "string") return field;
  return field[lang] || field.en || field.ar || Object.values(field).find(Boolean) || "";
}

// Arabic alphabet used for the alphabetical index
export const ARABIC_LETTERS = [
  "ا","ب","ت","ث","ج","ح","خ","د","ذ","ر","ز","س","ش","ص","ض","ط","ظ","ع","غ","ف","ق","ك","ل","م","ن","ه","و","ي",
];

export const LATIN_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

// Normalize Arabic first letter (strip ال prefix, alef variants)
export function arabicInitial(name) {
  if (!name) return "";
  let s = name.trim();
  if (s.startsWith("ال")) s = s.slice(2);
  const c = s.charAt(0);
  const alefVariants = { "أ": "ا", "إ": "ا", "آ": "ا" };
  return alefVariants[c] || c;
}
